export default  {
    "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
    "title": "Formula E - 2024-25 Season Sustainability Report",
    "shortTitle": "",
    "description": "",
    "width": 1263,
    "height": 893,
    "currentLanguage": "EN",
    "languages": [
      {
        code: "EN",
        text: "English",
        href: "#"
      },
    ],
    "basePath": "/season2024-25",
    // "basePath": "",
    "companyLogo": "logo.png",
    "publishURL": "https://sustainabilityreport.fiaformulae.com/season2024-25/static/_thumbs/",
    "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
    "options": {
      "doublePage": true,
      "rightToLeft": false,
      "searchEnabled": true,
      "downloadEnabled": true,
      "downloadPath": '/season2024-25/static/_content/formula-e-2024-25-sustainability-report.pdf',
      "printEnabled": false,
      "zoom": {
        "navEnabled": false,
        "sliderEnabled": true,
        "clickEnabled": true,
        "scrollEnabled": true,
      },
      "contents": {
        "enabled": true,
        "pinned": false,
        "numbers": true,
        "titles": true,
      },
      "languagesEnabled": false,
      "editionsEnabled": false,
      "mobileSwitch": false,
      "guideEnabled": false,
      "galleryCaptions": {},
      "fullscreenEnabled": true,
    },
    "pages": [[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 0,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg1.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScaleC 1-sub" style="top:-147px;left:535px;" src="/season2024-25/static/_content/1-sub-1.png"/>
      <img class="abs halfScaleC 1-sub" style="top:-198px;left:532px;" src="/season2024-25/static/_content/1-line-1.png"/>
      <img class="abs halfScaleC 1-title" style="top:746px;left:511px;" src="/season2024-25/static/_content/1-title-1.png"/>
      <img class="abs halfScaleC 1-title" style="top:801px;left:425px;" src="/season2024-25/static/_content/1-title-2.png"/>
      <img class="abs halfScaleC 1-logo" style="top:-9px;left:821px;" src="/season2024-25/static/_content/logo.png"/>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:406px; left:1159px; width:84px; height:86px;"></div>     
      
      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          pg1Anim.staggerFromTo(cOf("1-sub"), 0.7, {opacity:0, x: -40}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)
          .staggerFromTo(cOf("1-title"), 0.6, {opacity:0, x: 50}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.5)
          .fromTo(cOf("1-logo"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.8);

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg1Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "2024/25 SEASON SUSTAINABILITY REPORT  20 24 / 25 RACING FOR BETTER FUTURES"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 1,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg2.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToPage(3);" style="top:88px; left:258px; width:390px; height:31px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(4);" style="top:138px; left:262px; width:378px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(5);" style="top:163px; left:262px; width:378px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(7);" style="top:192px; left:262px; width:378px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(10);" style="top:219px; left:262px; width:378px; height:21px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(11);" style="top:306px; left:258px; width:390px; height:61px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(12);" style="top:378px; left:262px; width:378px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(14);" style="top:409px; left:262px; width:378px; height:38px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(15);" style="top:459px; left:262px; width:378px; height:38px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(16);" style="top:501px; left:262px; width:378px; height:21px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(17);" style="top:565px; left:258px; width:390px; height:31px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(18);" style="top:605px; left:262px; width:378px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(20);" style="top:633px; left:262px; width:378px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(21);" style="top:663px; left:262px; width:378px; height:40px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(22);" style="top:707px; left:262px; width:378px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(23);" style="top:735px; left:262px; width:378px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(24);" style="top:760px; left:262px; width:378px; height:21px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(25);" style="top:88px; left:845px; width:390px; height:61px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(26);" style="top:163px; left:845px; width:365px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(28);" style="top:192px; left:845px; width:365px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(29);" style="top:219px; left:845px; width:365px; height:21px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(30);" style="top:306px; left:845px; width:390px; height:61px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(31);" style="top:378px; left:845px; width:365px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(33);" style="top:409px; left:845px; width:365px; height:21px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(34);" style="top:434px; left:845px; width:365px; height:40px;"></div>
      <div class="addContentLink" onclick="Publish.goToPage(35);" style="top:482px; left:845px; width:365px; height:21px;"></div>

      <div class="addContentLink" onclick="Publish.goToPage(36);" style="top:572px; left:845px; width:276px; height:31px;"></div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg2Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg2Anim.stop();
          removeContentLinks();
        }
      `,
      "searchText": "1 2 3  CONTENT  CONTENTS  02  CONTENTS  INTRODUCTION		  03  CEO Foreword  4  Leading the Race for Progress  5  Season 2024/25 Stories  7  Governance  10  FORMULA EXCELLENCE		  11  They Pledge, We Deliver  12  Integrating Sustainability at Race Pace  14  Strengthening Oversight and Accountability  15  Maintaining our Leadership Position  16  FORMULA EQUITY 17 Bringing Communities into the Race  18  A Positive Legacy in Host Communities  20  Creating Opportunities with FIA Girls on Track  21  Delivering Social and Economic Impact  22  Community Benefits and Opportunities  23  A More Inclusive Workforce  24  4 5 6  2024/25 SEASON  FORMULA ENVIRONMENT  25  Net Zero is our Finish Line  26  Our Carbon Impact  28  Winning the Race on Emissions  29  FORMULA ECOSYSTEM  30  Value Through Values  31  Partners on our Journey to Net Zero  33  Envision Racing Named Sustainability Champion  34  Conversations to Unlock Ideas  35  GRI INDEX  36"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 2,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg3.jpg",
      "zoom": null,
      "content": `

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:406px; left:1159px; width:84px; height:86px;"></div>     

      `,
      "script": `
        function onPageEnter() {
          pg3Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "1 INTRO INTRO INTRO INTRO  INTRODUCTION"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 3,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg4.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg4Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "CEO FOREWORD The 2024/25 Season of the ABB FIA Formula E World Championship marked a pivotal shift in our journey. Formula E was created to prove that sport can be a powerful engine for innovation, human progress, and positive change, and we took that purpose to new heights by moving from setting ambitions to executing real, measurable action. As a sport with sustainability in our DNA, we’ve always known that our responsibilities go beyond the track. During the 2024/25 Season, we focused on implementation, embedding sustainable practices deep into our global operations, strengthening accountability across our supply chains, and delivering tangible outcomes for our host communities. From breaking ground on gender equality in motorsport to pioneering new standards in climate accounting, we strengthened our impact across our strategic pillars: Formula Excellence, Formula Equity, Formula Environment, and Formula Ecosystem. A major milestone came in our approach to climate action. As expectations around  04  INTRODUCTION  net zero continue to evolve, we progressed from traditional carbon neutrality towards a science-based, independently verified pathway centred on real emissions reductions, transparent reporting, and robust long-term planning. Following a rigorous independent audit, Formula E became the first sport certified under the BSI Net Zero Pathway, reinforcing our commitment to credible and transparent climate leadership aligned with ISO 14064 and IWA 42 standards. Equal progress was made on social impact and breaking down barriers across motorsport. In November 2024, we hosted the first all-women test session in FIA World Championship history, giving 17 drivers the opportunity to experience our GEN3 Evo race car and work directly with engineers. Beyond the track, five participants secured roles with Formula E teams, with three progressing into permanent positions within our ecosystem. At the same time, our Driving Force education initiative expanded its reach significantly, inspiring more than 61,000 pupils through teacher-led content and hosting hands-on STEM workshops across Jeddah, Miami, and London.  2024/25 SEASON  Jeff Dodds Chief Executive Officer, Formula E  Crucially, our efforts continue to set the benchmark on the global stage. For the fourth consecutive year, Formula E was ranked as the world's most sustainable sport by the Global Sustainability Benchmark in Sport (GSBS), earning an overall score of 85% and topping both the Environmental and Social categories among 78 global sports organisations. This recognition is a testament to the relentless dedication of our teams, partners, suppliers, manufacturers, race promoters, host cities, and wider Formula E community. At Formula E, we do not view sustainability as a finish line to cross, but as a continuous pursuit to act faster, push boundaries, and deliver more. The 2024/25 Season demonstrated what is possible when purpose meets implementation, and as we look ahead, our drive to translate purpose into lasting action only grows stronger."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 4,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg5.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "LEADING THE RACE FOR PROGRESS Formula E was created to demonstrate that sport can be a platform for innovation, human progress and positive change. During the 2024/25 Season, that mission took another important step forward. Across the Championship, the focus was increasingly on implementation: continually embedding sustainability in the way we operate, strengthening accountability, improving how we measure impact and delivering tangible outcomes for our communities and wider world. The result was a season defined not by new ambitions, but by progress. One of the  05  INTRODUCTION  most significant milestones came in our approach to climate action. As expectations around Net Zero continue to evolve, Formula E continued its transition from carbon neutrality towards a science-based, independently verified pathway centred on emissions reductions, robust carbon accounting and long-term planning. Following an external audit, Formula E became the first sport certified under the BSI Net Zero Pathway, reinforcing our commitment to credible and transparent climate leadership. But the 2024/25 Season was about more than climate action alone.  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 5,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg6.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg6Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "LEADING THE RACE FOR PROGRESS  From enhanced emissions reporting to the introduction of a socio-economic impact framework, we sought to ensure that progress is supported by evidence, transparency and accountability.  (CONTINUED)  We expanded opportunities for women in motorsport through the first all-women test session in FIA World Championship history. We more than tripled the number of people positively impacted through our social impact programmes. We invested in local communities across our race calendar, reached thousands of young people through sustainability education initiatives and continued to strengthen the governance systems that underpin our long-term approach.  None of this work happens in isolation. It is made possible by the collective efforts of our teams, partners, suppliers, manufacturers, race promoters, host cities and wider Formula E community. This report tells the story of that progress. It reflects a season in which sustainability became further embedded across the championship and demonstrates how Formula E continues to translate its purpose into action.  At the same time, we developed new ways of understanding and measuring our impact.  06  INTRODUCTION  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 6,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg7.jpg",
      "zoom": null,
      "content": `
      
      <img class="abs halfScale 7-number" style="top:440px;left:749px;" src="/season2024-25/static/_content/7-no-1.png"/>
      <h1 id="7-no" class="abs feSans-miniBd 7-no" style="top:560px;left:747px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 17}' ></h1>
      <h1 id="7-no" class="abs feSans-miniBd 7-no" style="top:560px;left:986px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 3}' ></h1>
      <h1 id="7-no" class="abs feSans-miniBd 7-no" style="top:660px;left:747px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 5}' ></h1>
      <h1 id="7-no" class="abs feSans-miniBd 7-no" style="top:660px;left:986px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 3}' ></h1>

      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 7-click-1" style="top:715px;left:60px;" onclick="showSevenPopOne()" src="/season2024-25/static/_content/7-click-1.png"/>
      <div id="7-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 7-pop-1" style="top:278px;left:172px;" src="/season2024-25/static/_content/7-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:736px;left:203px;width:285px;height:43px;" onclick="hideOverlay('7-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 7-click-2" style="top:26px;left:704px;" onclick="showSevenPopTwo()" src="/season2024-25/static/_content/7-click-2.png"/>
      <div id="7-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 7-pop-2" style="top:54px;left:714px;" src="/season2024-25/static/_content/7-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:73px;left:1157px;width:42px;height:42px;" onclick="hideOverlay('7-pop-2')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg7Anim = new TimelineMax();
          pg7Anim.fromTo(cOf("7-number"), 0.6, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          .fromTo(cOf("7-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[0])}}, 1.0)
          .fromTo(cOf("7-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[1])}}, 1.0)
          .fromTo(cOf("7-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[2])}}, 1.0)
          .fromTo(cOf("7-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("7-no")[3])}}, 1.0);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showSevenPopOne() {
          showOverlay('7-pop-1')
        }

        function closeSevenPopOne() {
          hideOverlay('7-pop-1')
        }

        function showSevenPopTwo() {
          showOverlay('7-pop-2')
        }

        function CloseSevenPopTwo() {
          hideOverlay('7-pop-2')
        }

        function onPageLeave() {
          pg7Anim.stop();
          resetNumbers("7-no");
          closeSevenPopOne();
          removeContentLinks()
        }
      `,
      "searchText": "2024/25 2024/25  CLICK TO SEE ALL-WOMEN TEST DRIVER LINE-UP  2024/25 2024/25 2024/25 2024/25 2024/25 2024/25  SEASON STORIES  2024/25  1 07  1  ALL-WOMEN TEST BREAKS DOWN BARRIERS  ST  Motorsport has no shortage of talented women drivers. The challenge has often been access to opportunities at the highest level. In November 2024, we hosted the first all-women test session in the history of an FIA World Championship, giving 17 drivers the opportunity to experience Formula E machinery and work directly with our teams.  INTRODUCTION  all-women test session in FIA World Championship history  17  3  5  3  drivers participated  participants secured Formula E team roles  CLICK TO READ MORE  2024/25 SEASON  hours of track running  participants progressed into permanent positions"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 7,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg8.jpg",
      "zoom": null,
      "content": `
      
      <h1 id="8-no" class="abs feSans-miniBd 8-no" style="top:86px;left:972px; font-size: 3.4em; font-weight: 300; color: #0000ff; padding: 0px; margin: 0px;"  data-number='{"to": 50, "append": "%"}' ></h1>
      <h1 id="8-no" class="abs feSans-miniBd 8-no" style="top:209px;left:973px; font-size: 3.4em; font-weight: 300; color: #0000ff; padding: 0px; margin: 0px;"  data-number='{"to": 27.5, "decimals": 1, "append": "%"}' ></h1>
      <h1 id="8-no" class="abs feSans-miniBd 8-no" style="top:325px;left:973px; font-size: 3.4em; font-weight: 300; color: #0000ff; padding: 0px; margin: 0px;"  data-number='{"to": 90, "append": "%"}' ></h1>

      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 8-click-1" style="top:415px;left:400px;" onclick="showEightPopOne()" src="/season2024-25/static/_content/8-click-1.png"/>
      <div id="8-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 8-pop-1" style="top:98px;left:172px;" src="/season2024-25/static/_content/8-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:726px;left:868px;width:285px;height:43px;" onclick="hideOverlay('8-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg8Anim = new TimelineMax();
          pg8Anim.fromTo(cOf("8-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[0])}}, 1.0)
          .fromTo(cOf("8-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[1])}}, 1.0)
          .fromTo(cOf("8-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("8-no")[2])}}, 1.0);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showEightPopOne() {
          showOverlay('8-pop-1')
        }

        function closeEightPopOne() {
          hideOverlay('8-pop-1')
        }

        function onPageLeave() {
          pg8Anim.stop();
          resetNumbers("8-no");
          closeEightPopOne();
          removeContentLinks()
        }
      `,
      "searchText": "2024/25 2024/25 2024/25 2024/25 2024/25 2024/25 2024/25 2024/25  SEASON STORIES  2024/25  FIRST NET ZERO PATHWAY CERTIFIED SPORT Net zero has become one of the most widely used terms in sustainability, and is also one of the most misunderstood. When we first established our carbon neutrality programme, it reflected the standards and expectations of the time. But as climate science, regulation and stakeholder expectations have evolved, so too has the definition of what credible climate action looks like.  Today, organisations are increasingly expected to demonstrate how they will reduce emissions over time, supported by robust data, transparent reporting and independently verified plans. The focus has shifted from offsetting emissions to reducing them. In the 2024/25 Season, we continued to evolve our approach in line with that change.  CLICK TO READ MORE  2 08  INTRODUCTION  2024/25 SEASON  50%  Scope 1 & 2 reduction target by 2030  27.5% Scope 3 reduction target by 2030  90%  Scope 1, 2 & 3 reduction target by 2050 at the latest"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 8,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg9.jpg",
      "zoom": null,
      "content": `
      
      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 9-click-1" style="top:702px;left:67px;" onclick="showNinePopOne()" src="/season2024-25/static/_content/9-click-1.png"/>
      <div id="9-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 9-pop-1" style="top:198px;left:172px;" src="/season2024-25/static/_content/9-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:736px;left:203px;width:285px;height:43px;" onclick="hideOverlay('9-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 9-click-2" style="top:702px;left:556px;" onclick="showNinePopTwo()" src="/season2024-25/static/_content/9-click-2.png"/>
      <div id="9-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 9-pop-2" style="top:50px;left:172px;" src="/season2024-25/static/_content/9-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:71px;left:1152px;width:43px;height:43px;" onclick="hideOverlay('9-pop-2')"></div>

        <!-- animations -->

        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:181px;left:648px; font-size: 4.2em; font-weight: 300; color: #ffc400; padding: 0px; margin: 0px;"  data-number='{"to": 61678, "comma": true}' ></h1>
        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:266px;left: 701px; font-size: 4.2em; font-weight: 300; color: #ffc400; padding: 0px; margin: 0px;"  data-number='{"to": 1288, "comma": true}' ></h1>

        <img class="abs halfScaleC 9-sub" style="top:356px;left:179px;" src="/season2024-25/static/_content/9-pop-2-sub-1.png"/>
        <img class="abs halfScaleC 9-piechart" style="top:358px;left:217px;" src="/season2024-25/static/_content/9-pop-2-piechart-1.png"/>
        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:411px;left:325px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 77, "append": "%"}' ></h1>
        <img class="abs halfScaleC 9-text" style="top:460px;left:210px;" src="/season2024-25/static/_content/9-pop-2-text-1.png"/>

        <img class="abs halfScaleC 9-piechart" style="top:358px;left:569px;" src="/season2024-25/static/_content/9-pop-2-piechart-2.png"/>
        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:411px;left:676px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 77, "append": "%"}' ></h1>
        <img class="abs halfScaleC 9-text" style="top:461px;left:590px;" src="/season2024-25/static/_content/9-pop-2-text-2.png"/>

        <img class="abs halfScaleC 9-piechart" style="top:358px;left:868px;" src="/season2024-25/static/_content/9-pop-2-piechart-3.png"/>
        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:411px;left:974px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 2, "append": "/"}' ></h1>
        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:411px;left:1038px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 3}' ></h1>
        <img class="abs halfScaleC 9-text" style="top:461px;left:886px;" src="/season2024-25/static/_content/9-pop-2-text-3.png"/>


        <img class="abs halfScaleC 9-sub" style="top:549px;left:179px;" src="/season2024-25/static/_content/9-pop-2-sub-2.png"/>
        <img class="abs halfScaleC 9-piechart" style="top:552px;left:217px;" src="/season2024-25/static/_content/9-pop-2-piechart-4.png"/>
        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:603px;left:325px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 90, "append": "%"}' ></h1>
        <img class="abs halfScaleC 9-text" style="top:654px;left:205px;" src="/season2024-25/static/_content/9-pop-2-text-4.png"/>

        <img class="abs halfScaleC 9-piechart" style="top:552px;left:569px;" src="/season2024-25/static/_content/9-pop-2-piechart-5.png"/>
        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:603px;left:674px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 90, "append": "%"}' ></h1>
        <img class="abs halfScaleC 9-text" style="top:654px;left:588px;" src="/season2024-25/static/_content/9-pop-2-text-5.png"/>

        <img class="abs halfScaleC 9-piechart" style="top:552px;left:866px;" src="/season2024-25/static/_content/9-pop-2-piechart-6.png"/>
        <h1 id="9-no" class="abs feSans-miniBd 9-no" style="top:603px;left:973px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 83, "append": "%"}' ></h1>
        <img class="abs halfScaleC 9-text" style="top:654px;left:879px;" src="/season2024-25/static/_content/9-pop-2-text-6.png"/>
      </div>

      <img class="abs halfScaleC 9-icon" style="top:644px;left:666px;" src="/season2024-25/static/_content/9-icon.png"/>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg9Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }
 
        function showNinePopOne() {
          showOverlay('9-pop-1')
        }

        function closeNinePopOne() {
          hideOverlay('9-pop-1')
        }

        function showNinePopTwo() {
          showOverlay('9-pop-2');
          pg9Anim = new TimelineMax();
          pg9Anim.fromTo(cOf("9-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[0])}}, 1.0)
          .fromTo(cOf("9-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[1])}}, 1.1)
          .fromTo(cOf("9-sub"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)
          .fromTo(cOf("9-piechart"), 0.6, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)
          .fromTo(cOf("9-text"), 0.6, {opacity:0, y: 25}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)
          .fromTo(cOf("9-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[2])}}, 1.7)
          .fromTo(cOf("9-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[3])}}, 1.7)
          .fromTo(cOf("9-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[4])}}, 1.7)
          .fromTo(cOf("9-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[5])}}, 1.7)
          .fromTo(cOf("9-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[6])}}, 1.7)
          .fromTo(cOf("9-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[7])}}, 1.7)
          .fromTo(cOf("9-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("9-no")[8])}}, 1.7);
        }

        function closeNinePopTwo() {
          hideOverlay('9-pop-2')
          resetNumbers("9-no");
        }

        function onPageLeave() {
          pg9Anim.stop();
          resetNumbers("9-no");
          closeNinePopOne();
          closeNinePopTwo();
          removeContentLinks()
        }
      `,
      "searchText": "2024/25 2024/25 2024/25 2024/25 2024/25 2024/25 2024/25 2024/25  SEASON STORIES  2024/25  3 09  INTRODUCTION  INSPIRING THE NEXT GENERATION OF CHANGEMAKERS Many young people are concerned about the future of the planet and need support to believe they can play a meaningful role in shaping it. That is the idea behind Driving Force, Formula E’s sustainability and STEM education programme designed to connect the excitement of electric racing with real-world challenges and inspire the next generation of changemakers.  CLICK TO READ MORE  CLICK TO SEE THE NUMBERS  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 9,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg10.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg10Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "GOVERNANCE  MANAGEMENT SYSTEMS AND STANDARDS  FORMULA E HAS A ROBUST GOVERNANCE STRUCTURE IN PLACE TO ENSURE SUSTAINABILITY REMAINS A CORE STRATEGIC PRIORITY ACROSS THE BUSINESS.  BOARD-LEVEL ENGAGEMENT AND OVERSIGHT The Board holds ultimate responsibility for sustainability-related decisionmaking. It reviews strategy, oversees major capital expenditures, guides annual budgets and shapes innovation and R&D priorities. Board-level oversight of sustainability-related issues takes place on a case-by-case basis, with key matters reviewed and addressed as they arise.  CEO ROLE IN SUSTAINABILITY LEADERSHIP  STRATEGIC OVERSIGHT Our VP of Sustainability leads the strategic assessment and management of sustainabilityrelated risks and opportunities. Sustainability considerations are integrated into Leadership Team discussions as needed, helping to inform strategic, financial and operational planning.  FINANCIAL INCENTIVES  Sustainability is embedded within our business KPIs, creating clear priorities and performance expectations across the company. For relevant employees, achievement against these KPIs also influences bonus-related financial incentives.  Our CEO holds ultimate accountability for the management of sustainability-related risks and opportunities, delegating responsibility for specific issues to the relevant departments as appropriate.  10  INTRODUCTION  2024/25 SEASON  Our sustainability management system is underpinned by internationally recognised frameworks and standards, including ISO 20121 for sustainable event management, ISO 14064 for greenhouse gas accounting and verification, IWA 42 for net zero guidelines and the UNFCCC Sports for Climate Action Framework. Together, these frameworks define sustainability-related roles, responsibilities and actions across all levels of the business. Key responsibilities are embedded within job descriptions, while sustainability-related KPIs, including our science-based targets (SBTs), support decision-making and drive emissions reductions."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 10,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg11.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:406px; left:1159px; width:84px; height:86px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg1Anim = new TimelineMax();
          
          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "2 FORMULA FORMULA FORMULA FORMULA  EXCELLENCE"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 11,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg12.jpg",
      "zoom": null,
      "content": `

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg12Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "A SHARPER FOCUS ON IMPLEMENTATION  THIS SECTION OF THE REPORT  THEY PLEDGE, WE DELIVER The 2024/25 Season marked an important shift in Formula E's sustainability journey. Having spent previous seasons building frameworks, policies and management systems, implementation became more focused.  INTEGRATING  From governance and climate action to human rights and supplier accountability, sustainability became increasingly embedded in the way we operate. This chapter explores how stronger systems, clearer accountability and more robust data are helping turn ambition into action across the Championship.  We built and promoted human  12  FORMULA EXCELLENCE  SUSTAINABILITY AT RACE PACE  The emphasis was on implementation of sustainability policies across the business. STRENGTHENING OVERSIGHT AND ACCOUNTABILITY rights and supplier policies. MAINTAINING OUR LEADERSHIP POSITION Ranked number one for the fourth year in a row by the Global Sustainability Benchmark in Sport (GSBS).  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 12,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg13.jpg",
      "zoom": null,
      "content": `

      <img class="abs halfScale 13-number" style="top:65px;left:495px;" src="/season2024-25/static/_content/13-no-1.png"/>

      <h1 id="13-no" class="abs feSans-miniBd 13-no" style="top:358px;left:679px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 85}' ></h1>

      <img class="abs halfScale 13-perc" style="top:401px;left:902px;" src="/season2024-25/static/_content/percentage.png"/>
      <img class="abs halfScale 13-perc" style="top:381px;left:1000px;" src="/season2024-25/static/_content/13-block-1.png"/>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg13Anim = new TimelineMax();
          pg13Anim.fromTo(cOf("13-number"), 0.6, {opacity:0, x: 25}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)
          pg13Anim.fromTo(cOf("13-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("13-no")[0])}}, 1.2);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg13Anim.stop();
          resetNumbers("13-no");
          removeContentLinks()
        }
      `,
      "searchText": "FORMULA FORMULA FORMULA FORMULA  1  ST  IN THE GLOBAL SUSTAINABILITY BENCHMARK IN SPORT RANKINGS  EXCELLENCE S_11  85 BEST  %  IN NUMBERS IN NUMBERS IN NUMBERS IN NUMBERS  OVERALL SCORE  - SOCIAL PERFORMANCE - ENVIRONMENTAL PERFORMANCE  13  FORMULA EXCELLENCE  2024/25 SEASON  DEDICATED ESG POLICY DEVELOPED MOST COMPREHENSIVE IMPACT DATA COLLECTION"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 13,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg14.jpg",
      "zoom": null,
      "content": `

        <!-- pop one -->
        <img class="abs halfScaleC halfpulse animatedpulse pointer 14-click-1" style="top:414px;left:436px;" onclick="showFourteenPopOne()" src="/season2024-25/static/_content/14-click-1.png"/>
        <div id="14-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 14-pop-1" style="top:424px;left:38px;" src="/season2024-25/static/_content/14-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:433px;left:582px;width:285px;height:43px;" onclick="hideOverlay('14-pop-1')"></div>
          <div class="abs contentLinkNone pointer" style="top:706px;left:1142px;width:43px;height:43px;" onclick="hideOverlay('14-pop-1')"></div>
        </div>

        <!-- pop two -->
        <img class="abs halfScaleC halfpulse animatedpulse pointer 14-click-2" style="top:174px;left:783px;" onclick="showFourteenPopTwo()" src="/season2024-25/static/_content/14-click-2.png"/>
        <div id="14-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 14-pop-2" style="top:54px;left:856px;" src="/season2024-25/static/_content/14-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:725px;left:1015px;width:42px;height:42px;" onclick="hideOverlay('14-pop-2')"></div>
        </div>
  
        <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
        
      `,
      "script": `
        function onPageEnter() {
          pg14Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showFourteenPopOne() {
          showOverlay('14-pop-1')
        }

        function closeFourteenPopOne() {
          hideOverlay('14-pop-1')
        }

        function showFourteenPopTwo() {
          showOverlay('14-pop-2')
        }

        function closeFourteenPopTwo() {
          hideOverlay('14-pop-2')
        }

        function onPageLeave() {
          pg3Anim.stop();
          closeFourteenPopOne();
          closeFourteenPopTwo();
          removeContentLinks()
        }
      `,
      "searchText": "INTEGRATING SUSTAINABILITY AT RACE PACE The 2024/25 Season marked an important shift in Formula E’s sustainability journey. While previous seasons focused on understanding risks, developing frameworks and establishing policies, the emphasis this year was on implementation.  Across the business, sustainability requirements were increasingly embedded into operational processes, supplier relationships, contractual arrangements and management systems. This helped ensure that sustainability considerations were reflected not only in strategic decisionmaking, but also in day-to-day activities throughout the championship.  CLICK TO READ MORE  14  FORMULA EXCELLENCE  2024/25 SEASON  CLICK TO READ ABOUT DATA COLLECTION"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 14,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg15.jpg",
      "zoom": null,
      "content": `
      
        <!-- pop one -->
        <img class="abs halfScaleC halfpulse animatedpulse pointer 15-click-1" style="top:255px;left:542px;" onclick="showFifteenPopOne()" src="/season2024-25/static/_content/15-click-1.png"/>
        <div id="15-pop-1" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 15-pop-1" style="top:271px;left:728px;" src="/season2024-25/static/_content/15-pop-1.png"/>
          <div class="abs contentLinkNone pointer" style="top:703px;left:942px;width:43px;height:43px;" onclick="hideOverlay('15-pop-1')"></div>
        </div>

        <!-- pop two -->
        <img class="abs halfScaleC halfpulse animatedpulse pointer 15-click-1" style="top:677px;left:743px;" onclick="showFifteenPopTwo()" src="/season2024-25/static/_content/15-click-2.png"/>
        <div id="15-pop-2" class="standardTransition contentOverlay hidden noclick">
          <img class="abs halfScale 15-pop-2" style="top:456px;left:391px;" src="/season2024-25/static/_content/15-pop-2.png"/>
          <div class="abs contentLinkNone pointer" style="top:469px;left:1138px;width:43px;height:43px;" onclick="hideOverlay('15-pop-2')"></div>
        </div>

        <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg15Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showFifteenPopOne() {
          showOverlay('15-pop-1')
        }

        function closeFifteenPopOne() {
          hideOverlay('15-pop-1')
        }

        function showFifteenPopTwo() {
          showOverlay('15-pop-2')
        }

        function closeFifteenPopTwo() {
          hideOverlay('15-pop-2')
        }

        function onPageLeave() {
          pg3Anim.stop();
          closeFifteenPopOne();
          closeFifteenPopTwo();
          removeContentLinks()
        }
      `,
      "searchText": "STRENGTHENING OVERSIGHT AND ACCOUNTABILITY We continued to strengthen the systems and processes that support responsible business practices across the Championship.  Insights from these reviews help inform future actions and strengthen oversight of suppliers, contractors and event operations.  Respect for human rights forms part of Formula E’s broader approach to responsible business. During the 2024/25 Season, a number of policies, controls and processes were further embedded across the organisation, including our Human and Child Rights Policy, Whistleblowing Policy, supplier due diligence procedures and grievance mechanisms.  This work supports ongoing efforts to promote fair working conditions, worker welfare, health and safety, responsible employment  practices and respect for local labour requirements across all markets in which we operate.  CLICK TO READ ABOUT REPORTING REQUIREMENTS FOR SUPPLIERS  AN INTEGRATED MANAGEMENT APPROACH  These measures support the identification, prevention and management of human rights risks across our operations and supply chain. We also continued to undertake modern slavery assessments and audits at selected race locations based on risk considerations.  15  FORMULA EXCELLENCE  CLICK TO READ MORE  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 15,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg16.jpg",
      "zoom": null,
      "content": `
      
      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 16-click-1" style="top:481px;left:-90px;" onclick="showSixteenPopOne()" src="/season2024-25/static/_content/16-click-1.png"/>
      <div id="16-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 16-pop-1" style="top:204px;left:36px;" src="/season2024-25/static/_content/16-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:502px;left:52px;width:285px;height:43px;" onclick="hideOverlay('16-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:727px;left:695px;width:43px;height:43px;" onclick="hideOverlay('16-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 16-click-2" style="top:-39px;left:851px;" onclick="showSixteenPopTwo()" src="/season2024-25/static/_content/16-click-2.png"/>
      <div id="16-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 16-pop-2" style="top:69px;left:972px;" src="/season2024-25/static/_content/16-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:83px;left:1160px;width:43px;height:43px;" onclick="hideOverlay('16-pop-2')"></div>

        <!-- animations -->
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:387px;left:1014px; font-size: 4.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 85}' ></h1>
        <img class="abs halfScaleC 16-perc" style="top:392px;left:1100px;" src="/season2024-25/static/_content/percentage-white.png"/>

        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:511px;left:1066px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 57, "append": "%"}' ></h1>

        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:601px;left:1078px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 78}' ></h1>

        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:688px;left:1061px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 1700, "comma" : true, "append": "+"}' ></h1>
      </div>

      <!-- pop three -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 16-click-3" style="top:628px;left:-90px;" onclick="showSixteenPopThree()" src="/season2024-25/static/_content/16-click-3.png"/>
      <div id="16-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 16-pop-3" style="top:68px;left:51px;" src="/season2024-25/static/_content/16-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:89px;left:1143px;width:43px;height:43px;" onclick="hideOverlay('16-pop-3')"></div>

        <!-- animations -->

        <img class="abs halfScale 16-text" style="top:199px;left:96px;" src="/season2024-25/static/_content/16-pop-3-text-1.png"/>
        <img class="abs halfScale 16-bar" style="top:223px;left:94px;" src="/season2024-25/static/_content/16-pop-3-bar-1.png"/>
        <img class="abs halfScaleC 16-line-dotted" style="top:153px;left:727px;" src="/season2024-25/static/_content/16-pop-3-industry-line.png"/>
        <img class="abs halfScaleC 16-line" style="top:147px;left:998px;" src="/season2024-25/static/_content/16-pop-3-formulae-line.png"/>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:180px;left:759px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 62,"append": "%"}' ></h1>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:177px;left:1027px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 88,"append": "%"}' ></h1>

        <img class="abs halfScale 16-text" style="top:292px;left:96px;" src="/season2024-25/static/_content/16-pop-3-text-2.png"/>
        <img class="abs halfScale 16-bar" style="top:315px;left:94px;" src="/season2024-25/static/_content/16-pop-3-bar-2.png"/>
        <img class="abs halfScaleC 16-line-dotted" style="top:245px;left:549px;" src="/season2024-25/static/_content/16-pop-3-industry-line.png"/>
        <img class="abs halfScaleC 16-line" style="top:239px;left:905px;" src="/season2024-25/static/_content/16-pop-3-formulae-line.png"/>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:279px;left:580px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 45,"append": "%"}' ></h1>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:272px;left:934px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 79,"append": "%"}' ></h1>

        <img class="abs halfScale 16-text" style="top:389px;left:96px;" src="/season2024-25/static/_content/16-pop-3-text-3.png"/>
        <img class="abs halfScale 16-bar" style="top:410px;left:94px;" src="/season2024-25/static/_content/16-pop-3-bar-3.png"/>
        <img class="abs halfScaleC 16-line-dotted" style="top:339px;left:685px;" src="/season2024-25/static/_content/16-pop-3-industry-line.png"/>
        <img class="abs halfScaleC 16-line" style="top:334px;left:998px;" src="/season2024-25/static/_content/16-pop-3-formulae-line.png"/>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:371px;left:717px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 58,"append": "%"}' ></h1>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:366px;left:1027px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 88,"append": "%"}' ></h1>

        <img class="abs halfScale 16-text" style="top:483px;left:96px;" src="/season2024-25/static/_content/16-pop-3-text-4.png"/>
        <img class="abs halfScale 16-bar" style="top:504px;left:94px;" src="/season2024-25/static/_content/16-pop-3-bar-4.png"/>
        <img class="abs halfScaleC 16-line-dotted" style="top:434px;left:695px;" src="/season2024-25/static/_content/16-pop-3-industry-line.png"/>
        <img class="abs halfScaleC 16-line" style="top:428px;left:956px;" src="/season2024-25/static/_content/16-pop-3-formulae-line.png"/>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:463px;left:727px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 59,"append": "%"}' ></h1>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:461px;left:985px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 84,"append": "%"}' ></h1>

        <img class="abs halfScale 16-text" style="top:581px;left:94px;" src="/season2024-25/static/_content/16-pop-3-text-5.png"/>
        <img class="abs halfScale 16-bar" style="top:615px;left:94px;" src="/season2024-25/static/_content/16-pop-3-bar-5.png"/>
        <img class="abs halfScaleC 16-line-dotted" style="top:545px;left:674px;" src="/season2024-25/static/_content/16-pop-3-industry-line.png"/>
        <img class="abs halfScaleC 16-line" style="top:539px;left:967px;" src="/season2024-25/static/_content/16-pop-3-formulae-line.png"/>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:575px;left:705px; font-size: 1.1em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 57,"append": "%"}' ></h1>
        <h1 id="16-no" class="abs feSans-miniBd 16-no" style="top:570px;left:995px; font-size: 1.8em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 85,"append": "%"}' ></h1>
        
        <img class="abs halfScale 16-key" style="top:712px;left:106px;" src="/season2024-25/static/_content/16-pop-3-key-1.png"/>
        <img class="abs halfScale 16-key" style="top:712px;left:305px;" src="/season2024-25/static/_content/16-pop-3-key-2.png"/>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg16Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showSixteenPopOne() {
          showOverlay('16-pop-1')
        }

        function closeSixteenPopOne() {
          hideOverlay('16-pop-1')
        }

        function showSixteenPopTwo() {
          showOverlay('16-pop-2');
          pg16Anim = new TimelineMax();
          pg16Anim.fromTo(cOf("16-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[0])}}, 1.0)
          .fromTo(cOf("16-perc"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2)
          .fromTo(cOf("16-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[1])}}, 1.5)
          .fromTo(cOf("16-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[2])}}, 1.6)
          .fromTo(cOf("16-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[3])}}, 1.7);
        }

        function closeSixteenPopTwo() {
          hideOverlay('16-pop-2')
          resetNumbers("16-no");
        }

        function showSixteenPopThree() {
          showOverlay('16-pop-3');
          pg16Anim = new TimelineMax();
          pg16Anim.staggerFromTo(cOf("16-text"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 1)
          .staggerFromTo(cOf("16-bar"), 0.3, {scaleX: 0}, {scaleX:0.5, ease: Power2.easeOut}, 0.1, 1.2)
          .staggerFromTo(cOf("16-line-dotted"), 0.6, {opacity:0, y: -25}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1.4)
          .staggerFromTo(cOf("16-line"), 0.6, {opacity:0, y: -25}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.1, 1.5)
          .fromTo(cOf("16-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[4])}}, 1.7)
          .fromTo(cOf("16-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[5])}}, 1.8)
          .fromTo(cOf("16-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[6])}}, 1.9)
          .fromTo(cOf("16-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[7])}}, 2.0)
          .fromTo(cOf("16-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[8])}}, 2.1)
          .fromTo(cOf("16-no")[9], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[9])}}, 2.2)
          .fromTo(cOf("16-no")[10], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[10])}}, 2.3)
          .fromTo(cOf("16-no")[11], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[11])}}, 2.4)
          .fromTo(cOf("16-no")[12], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[12])}}, 2.5)
          .fromTo(cOf("16-no")[13], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("16-no")[13])}}, 2.6)
          .staggerFromTo(cOf("16-key"), 0.6, {opacity:0, x: -30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.1, 2.8);
        }

        function closeSixteenPopThree() {
          hideOverlay('16-pop-3')
          resetNumbers("16-no");
        }

        function onPageLeave() {
          pg16Anim.stop();
          resetNumbers("16-no");
          closeSixteenPopOne();
          closeSixteenPopTwo();
          closeSixteenPopThree();
          removeContentLinks()
        }
      `,
      "searchText": "MAINTAINING OUR LEADERSHIP POSITION For the fourth consecutive year, Formula E was ranked as the world's most sustainable sport by the Global Sustainability Benchmark in Sport (GSBS).  1  ST  OVERALL  for the fourth consecutive year  CLICK TO READ MORE  The independent assessment awarded Formula E the highest overall score across all participating organisations, recognising the continued progress made across environmental, social, governance and corporate performance.  CLICK TO READ MORE  CLICK TO SEE FORMULA E VS INDUSTRY AVERAGE  “  Formula E continues to lead the way in one of the most competitive global industries - now for the fourth consecutive year. Every year, when we review their data, it becomes clear that they have already moved ahead, continually advancing their practices and strengthening their approach to sustainability.” Christian Hartmann, CEO, Global Sustainability Benchmark in Sports (GSBS)  16  FORMULA EXCELLENCE  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 16,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg17.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:406px; left:1159px; width:84px; height:86px;"></div>     
      
      `,
      "script": `
        function onPageEnter() {
          pg17Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg17Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "3 FORMULA FORMULA FORMULA FORMULA  EQUITY"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 17,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg18.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg18Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg18Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "TRIPLING OUR SOCIAL IMPACT IN THE 2024/25 SEASON Our eleventh season marked our most impactful year yet. Guided by a new Theory of Change, we strengthened the alignment between our social impact programmes, expanded our reach and deepened our contribution to communities around the world.  in local community projects, we continued to use Formula E as a platform for positive change.  THIS SECTION OF THE REPORT  BRINGING COMMUNITIES INTO THE RACE  A POSITIVE LEGACY IN HOST COMMUNITIES Better Futures Fund evolves into a Championship-wide programme. EXTENDING THE REACH OF FIA GIRLS ON TRACK Offering opportunities to more young women. INSPIRING THE NEXT GENERATION OF CHANGEMAKERS Driving Force connects electric racing with real-world challenges.  Across our four flagship programmes, we positively impacted 86,007 people – more than triple the total reached in the 2023/24 Season. From empowering young changemakers and increasing opportunities in motorsport to investing  COMMUNITY BENEFITS AND OPPORTUNITIES More than 3,500 people participate in race engagement activities. A MORE INCLUSIVE WORKFORCE Bringing our people and social impact programmes under a single framework.  18  FORMULA EQUITY  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 18,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg19.jpg",
      "zoom": null,
      "content": `
      
      <h1 id="19-no" class="abs feSans-miniBd 19-no" style="top:40px;left:471px; font-size: 8.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 86007, "comma" : true}' ></h1>
      <img class="abs halfScale 19-block" style="top:40px;left:1054px;" src="/season2024-25/static/_content/19-block-1.png"/>

      <img class="abs halfScale 19-plus" style="top:358px;left:674px;" src="/season2024-25/static/_content/plus.png"/>
      <h1 id="19-no" class="abs feSans-miniBd 19-no" style="top:274px;left:733px; font-size: 8.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 241}' ></h1>
      <img class="abs halfScale 19-perc" style="top:325px;left:1026px;" src="/season2024-25/static/_content/percentage.png"/>
      <img class="abs halfScale 19-block" style="top:325px;left:1122px;" src="/season2024-25/static/_content/19-block-2.png"/>

      <h1 id="19-no" class="abs feSans-miniBd 19-no" style="top:560px;left:379px; font-size: 8.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 960}' ></h1>
      <img class="abs halfScale 19-block" style="top:550px;left:707px;" src="/season2024-25/static/_content/19-block-3.png"/>

      <h1 id="19-no" class="abs feSans-miniBd 19-no" style="top:534px;left:849px; font-size: 8.6em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 97}' ></h1>
      <img class="abs halfScale 19-block" style="top:485px;left:1039px;" src="/season2024-25/static/_content/19-block-4.png"/>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      `,
      "script": `
        function onPageEnter() {
          pg19Anim = new TimelineMax();
          pg19Anim.fromTo(cOf("19-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("19-no")[0])}}, 1)
          .fromTo(cOf("19-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("19-no")[1])}}, 1.1)
          .fromTo(cOf("19-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("19-no")[2])}}, 1.2)
          .fromTo(cOf("19-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("19-no")[3])}}, 1.3);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg19Anim.stop();
          removeContentLinks()
        }
      `,
      "searchText": "FORMULA FORMULA FORMULA FORMULA  86,007  EQUITY S_11  IN NUMBERS IN NUMBERS  PEOPLE POSITIVELY IMPACTED  +241  IN NUMBERS  %  GROWTH COMPARED WITH 2023/24 SEASON  97 960 IN NUMBERS  LOCAL COMMUNITY PARTNERS ENGAGED  19  FORMULA EQUITY  2024/25 SEASON  PROGRAMME ACTIVATIONS DELIVERED"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 19,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg20.jpg",
      "zoom": null,
      "content": `
      
      <h1 id="20-no" class="abs feSans-miniBd 20-no" style="top:185px;left:860px; font-size: 3.4em; font-weight: 300; color: #00ff0a; padding: 0px; margin: 0px;"  data-number='{"to": 250000, "preppend": "€", "comma" : true}' ></h1>
      <h1 id="20-no" class="abs feSans-miniBd 20-no" style="top:289px;left:956px; font-size: 3.4em; font-weight: 300; color: #00ff0a; padding: 0px; margin: 0px;"  data-number='{"to": 8847, "comma": true}' ></h1>
      <h1 id="20-no" class="abs feSans-miniBd 20-no" style="top:418px;left:966px; font-size: 3.4em; font-weight: 300; color: #00ff0a; padding: 0px; margin: 0px;"  data-number='{"to": 297}' ></h1>
      <h1 id="20-no" class="abs feSans-miniBd 20-no" style="top:543px;left:968px; font-size: 3.4em; font-weight: 300; color: #00ff0a; padding: 0px; margin: 0px;"  data-number='{"to": 11}' ></h1>

      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 20-click-1" style="top:408px;left:-91px;" onclick="showTwentyPopOne()" src="/season2024-25/static/_content/20-click-1.png"/>
      <div id="20-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 20-pop-1" style="top:415px;left:32px;" src="/season2024-25/static/_content/20-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:430px;left:48px;width:285px;height:43px;" onclick="hideOverlay('20-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:691px;left:761px;width:43px;height:43px;" onclick="hideOverlay('20-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 20-click-2" style="top:465px;left:-115px;" onclick="showTwentyPopTwo()" src="/season2024-25/static/_content/20-click-2.png"/>
      <div id="20-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 20-pop-2" style="top:68px;left:52px;" src="/season2024-25/static/_content/20-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:86px;left:1157px;width:43px;height:43px;" onclick="hideOverlay('20-pop-2')"></div>

        <!-- city clicks -->
        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:512px;left:267px;" onclick="openPop('20-cities', '20-city-1')" src="/season2024-25/static/_content/20-pop-2-city-1.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:372px;left:327px;" onclick="openPop('20-cities', '20-city-2')" src="/season2024-25/static/_content/20-pop-2-city-2.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:452px;left:417px;" onclick="openPop('20-cities', '20-city-3')" src="/season2024-25/static/_content/20-pop-2-city-3.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:430px;left:577px;" onclick="openPop('20-cities', '20-city-4')" src="/season2024-25/static/_content/20-pop-2-city-4.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:231px;left:555px;" onclick="openPop('20-cities', '20-city-5')" src="/season2024-25/static/_content/20-pop-2-city-5.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:268px;left:597px;" onclick="openPop('20-cities', '20-city-6')" src="/season2024-25/static/_content/20-pop-2-city-6.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:362px;left:674px;" onclick="openPop('20-cities', '20-city-7')" src="/season2024-25/static/_content/20-pop-2-city-7.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:589px;left:871px;" onclick="openPop('20-cities', '20-city-8')" src="/season2024-25/static/_content/20-pop-2-city-8.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:292px;left:913px;" onclick="openPop('20-cities', '20-city-9')" src="/season2024-25/static/_content/20-pop-2-city-9.png"/>

        <img class="abs halfScale halfpulse animatedpulse pointer 20-click-pop" style="top:342px;left:965px;" onclick="openPop('20-cities', '20-city-10')" src="/season2024-25/static/_content/20-pop-2-city-10.png"/>

        <!-- city pop -->
        <div id="20-city-1" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-1" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-1-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-1')"></div>
        </div>

        <div id="20-city-2" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-2" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-2-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-2')"></div>
        </div>

        <div id="20-city-3" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-3" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-3-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-3')"></div>
        </div>

        <div id="20-city-4" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-4" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-4-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-4')"></div>
        </div>

        <div id="20-city-5" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-5" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-5-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-5')"></div>
        </div>

        <div id="20-city-6" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-6" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-6-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-6')"></div>
        </div>

        <div id="20-city-7" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-7" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-7-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-7')"></div>
        </div>

        <div id="20-city-8" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-8" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-8-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-8')"></div>
        </div>

        <div id="20-city-9" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-9" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-9-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-9')"></div>
        </div>

        <div id="20-city-10" class="20-cities hidden noclick">
          <img class="abs halfScale 20-pop-2-city-10" style="top:67px;left:51px;" src="/season2024-25/static/_content/20-pop-2-city-10-pop.png"/>
          <div class="abs contentLinkNone pointer" style="top:92px;left:1150px;width:41px;height:42px;" onclick="closePop('20-city-10')"></div>
        </div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg20Anim = new TimelineMax();
          pg20Anim.fromTo(cOf("20-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("20-no")[0])}}, 1.0)
          .fromTo(cOf("20-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("20-no")[1])}}, 1.0)
          .fromTo(cOf("20-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("20-no")[2])}}, 1.0)
          .fromTo(cOf("20-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("20-no")[3])}}, 1.0);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showTwentyPopOne() {
          showOverlay('20-pop-1')
        }

        function closeTwentyPopOne() {
          hideOverlay('20-pop-1')
        }

        function openPop(klass, id) {
        popups = cOf(klass);
        ele = idOf(id);
        for(var i=0; i<popups.length; i++) {
          popups[i].className = "20-cities hidden noclick";
          }
          ele.className = 'visible'
        }

        function closePop(id) {
          ele = idOf(id);
        ele.className = '20-cities hidden noclick'
        }

        function showTwentyPopTwo() {
          showOverlay('20-pop-2')
        }

        function closeTwentyPopTwo() {
          hideOverlay('20-pop-2')
        }

        function onPageLeave() {
          pg20Anim.stop();
          resetNumbers("20-no");
          closeTwentyPopOne();
          closeTwentyPopTwo();
          removeContentLinks()
        }
      `,
      "searchText": "A POSITIVE LEGACY IN HOST COMMUNITIES Introduced in the 2023/24 Season, the Better Futures Fund was created to ensure Formula E leaves a positive legacy in the communities that host our races. By supporting local organisations addressing social and environmental challenges, the fund extends our impact beyond race week and helps create lasting benefits in host cities.  €250,000 invested across 10 host cities  8,847  people impacted through funded projects  297  CLICK TO READ MORE  people engaged through race-week activities  CLICK TO READ OUR SEASON 11 HIGHLIGHTS  11  local organisations supported  20  FORMULA EQUITY  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 20,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg21.jpg",
      "zoom": null,
      "content": `

      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click-1" style="top:416px;left:-92px;" onclick="showTwentyOnePopOne()" src="/season2024-25/static/_content/21-click-1.png"/>
      <div id="21-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 21-pop-1" style="top:424px;left:36px;" src="/season2024-25/static/_content/21-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:440px;left:52px;width:285px;height:43px;" onclick="hideOverlay('21-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:731px;left:1183px;width:43px;height:43px;" onclick="hideOverlay('21-pop-1')"></div>
      </div>
      
      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click-2" style="top:683px;left:796px;" onclick="showTwentyOnePopTwo()" src="/season2024-25/static/_content/21-click-2.png"/>
      <div id="21-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 21-pop-2" style="top:58px;left:44px;" src="/season2024-25/static/_content/21-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:725px;left:1136px;width:43px;height:43px;" onclick="hideOverlay('21-pop-2')"></div>
      </div>
      <img class="abs halfScale 21-image" style="top:663px;left:1099px;" src="/season2024-25/static/_content/21-image-1.png"/>
     
      <!-- pop three -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 21-click-3" style="top:446px;left:-92px;" onclick="showTwentyOnePopThree()" src="/season2024-25/static/_content/21-click-3.png"/>
      <div id="21-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 21-pop-3" style="top:52px;left:44px;" src="/season2024-25/static/_content/21-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:725px;left:1136px;width:43px;height:43px;" onclick="hideOverlay('21-pop-3')"></div>

        <!-- animations -->
        <h1 id="21-no" class="abs feSans-miniBd 21-no" style="top:569px;left:63px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 1272, "comma": true}' ></h1>
        <h1 id="21-no" class="abs feSans-miniBd 21-no" style="top:335px;left:492px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 97, "append": "%"}' ></h1>
        <h1 id="21-no" class="abs feSans-miniBd 21-no" style="top:335px;left:871px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 6}' ></h1>
        <h1 id="21-no" class="abs feSans-miniBd 21-no" style="top:482px;left:492px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 50, "append": "%"}' ></h1>
        <h1 id="21-no" class="abs feSans-miniBd 21-no" style="top:482px;left:871px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 10}' ></h1>
        <h1 id="21-no" class="abs feSans-miniBd 21-no" style="top:627px;left:492px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 38, "append": "%"}' ></h1>
        <h1 id="21-no" class="abs feSans-miniBd 21-no" style="top:627px;left:868px; font-size: 3.4em; font-weight: 300; color: #002d62; padding: 0px; margin: 0px;"  data-number='{"to": 5900, "append": "+", "comma": true}' ></h1>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>  
      
      `,
      "script": `
        function onPageEnter() {
          pg21Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showTwentyOnePopOne() {
          showOverlay('21-pop-1')
        }

        function closeTwentyOnePopOne() {
          hideOverlay('21-pop-1')
        }

        function showTwentyOnePopTwo() {
          showOverlay('21-pop-2')
        }

        function closeTwentyOnePopTwo() {
          hideOverlay('21-pop-2')
        }

        function showTwentyOnePopThree() {
          showOverlay('21-pop-3');
          pg21Anim = new TimelineMax();
          pg21Anim.fromTo(cOf("21-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[0])}}, 1.0)
          .fromTo(cOf("21-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[1])}}, 1.1)
          .fromTo(cOf("21-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[2])}}, 1.1)
          .fromTo(cOf("21-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[3])}}, 1.1)
          .fromTo(cOf("21-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[4])}}, 1.1)
          .fromTo(cOf("21-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[5])}}, 1.1)
          .fromTo(cOf("21-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("21-no")[6])}}, 1.1);
        }

        function closeTwentyOnePopThree() {
          hideOverlay('21-pop-3')
          resetNumbers("21-no");
        }

        function onPageLeave() {
          pg21Anim.stop();
          resetNumbers("21-no");
          closeTwentyOnePopOne();
          closeTwentyOnePopTwo();
          closeTwentyOnePopThree();
          removeContentLinks()
        }
      `,
      "searchText": "CREATING OPPORTUNITIES WITH FIA GIRLS ON TRACK Since its launch in 2016, FIA Girls on Track has become one of Formula E's flagship social impact programmes, creating opportunities for young women to explore careers in motorsport and STEM.  CLICK TO READ MORE  1,272 young women engaged across all race markets  CLICK TO SEE MORE NUMBERS  21  FORMULA EQUITY  CLICK TO READ ANNA’S STORY  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 21,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg22.jpg",
      "zoom": null,
      "content": `

      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 22-click-1" style="top:366px;left:-90px;" onclick="showTwentyTwoPopOne()" src="/season2024-25/static/_content/22-click-1.png"/>
      <div id="22-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 22-pop-1" style="top:372px;left:36px;" src="/season2024-25/static/_content/22-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:386px;left:52px;width:285px;height:43px;" onclick="hideOverlay('22-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:726px;left:1121px;width:43px;height:43px;" onclick="hideOverlay('22-pop-1')"></div>
      </div>
      
      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 22-click-2" style="top:630px;left:-119px;" onclick="showTwentyTwoPopTwo()" src="/season2024-25/static/_content/22-click-2.png"/>
      <div id="22-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 22-pop-2" style="top:162px;left:45px;" src="/season2024-25/static/_content/22-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:187px;left:1144px;width:43px;height:43px;" onclick="hideOverlay('22-pop-2')"></div>

        <!-- animations -->
        <h1 id="22-no" class="abs feSans-miniBd 22-no" style="top:619px;left:258px; font-size: 3.7em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 236000, "comma" : true}' ></h1>
        <h1 id="22-no" class="abs feSans-miniBd 22-no" style="top:254px;left:76px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 187, "preppend" : "€", "append" : "M"}' ></h1>
        <h1 id="22-no" class="abs feSans-miniBd 22-no" style="top:255px;left:419px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 159, "preppend" : "€", "append" : "M"}' ></h1>
        <h1 id="22-no" class="abs feSans-miniBd 22-no" style="top:255px;left:831px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 4300, "comma" : true}' ></h1>
        <h1 id="22-no" class="abs feSans-miniBd 22-no" style="top:389px;left:832px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 680}' ></h1>
        <h1 id="22-no" class="abs feSans-miniBd 22-no" style="top:510px;left:831px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 5.6, "preppend" : "€", "append" : "M", "decimals" : 1}' ></h1>
        <h1 id="22-no" class="abs feSans-miniBd 22-no" style="top:631px;left:830px; font-size: 3.4em; font-weight: 300; color: #000000; padding: 0px; margin: 0px;"  data-number='{"to": 2.7, "decimals" : 1}' ></h1>
      </div>

      <!-- pop three -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 22-click-3" style="top:703px;left:341px;" onclick="showTwentyTwoPopThree()" src="/season2024-25/static/_content/22-click-3.png"/>
      <div id="22-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 22-pop-3" style="top:302px;left:412px;" src="/season2024-25/static/_content/22-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:364px;left:604px;width:43px;height:43px;" onclick="hideOverlay('22-pop-3')"></div>
      </div>

      <!-- pop four -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 22-click-4" style="top:703px;left:769px;" onclick="showTwentyTwoPopFour()" src="/season2024-25/static/_content/22-click-4.png"/>
      <div id="22-pop-4" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 22-pop-4" style="top:302px;left:835px;" src="/season2024-25/static/_content/22-pop-4.png"/>
        <div class="abs contentLinkNone pointer" style="top:364px;left:1028px;width:43px;height:43px;" onclick="hideOverlay('22-pop-4')"></div>
      </div>
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>   
      `,
      "script": `
        function onPageEnter() {
          pg22Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showTwentyTwoPopOne() {
          showOverlay('22-pop-1')
        }

        function closeTwentyTwoPopOne() {
          hideOverlay('22-pop-1')
        }

        function showTwentyTwoPopTwo() {
          showOverlay('22-pop-2');
          pg22Anim = new TimelineMax();
          pg22Anim.fromTo(cOf("22-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[0])}}, 1.0)
          .fromTo(cOf("22-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[1])}}, 1.1)
          .fromTo(cOf("22-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[2])}}, 1.2)
          .fromTo(cOf("22-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[3])}}, 1.3)
          .fromTo(cOf("22-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[4])}}, 1.4)
          .fromTo(cOf("22-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[5])}}, 1.5)
          .fromTo(cOf("22-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("22-no")[6])}}, 1.6);
        }

        function closeTwentyTwoPopTwo() {
          hideOverlay('22-pop-2')
          resetNumbers("22-no");
        }
          
        function showTwentyTwoPopThree() {
          showOverlay('22-pop-3')
        }

        function closeTwentyTwoPopThree() {
          hideOverlay('22-pop-3')
        }

        function showTwentyTwoPopFour() {
          showOverlay('22-pop-4')
        }

        function closeTwentyTwoPopFour() {
          hideOverlay('22-pop-4')
        }

        function onPageLeave() {
          pg22Anim.stop();
          resetNumbers("22-no");
          closeTwentyTwoPopOne();
          closeTwentyTwoPopTwo();
          closeTwentyTwoPopThree();
          closeTwentyTwoPopFour();
          removeContentLinks()
        }
      `,
      "searchText": "DELIVERING SOCIAL AND ECONOMIC IMPACT Formula E exists to accelerate sustainable human progress. But understanding whether that progress is being achieved requires robust evidence, consistent measurement and a clear view of the outcomes created through our Theory of Change.  IMPACT METHODOLOGY CLICK TO TAB BELOW TO READ MORE  CLICK TO READ MORE  2024/25 SEASON SOCIO-ECONOMIC IMPACT CLICK TO READ MORE  22  FORMULA EQUITY  SOCIAL  2024/25 SEASON  ECONOMIC"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 22,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg23.jpg",
      "zoom": null,
      "content": `

      <h1 id="23-no" class="abs feSans-miniBd 23-no" style="top:51px;left:960px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 3503, "comma" : true}' ></h1>
      <h1 id="23-no" class="abs feSans-miniBd 23-no" style="top:177px;left:959px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to":5900, "comma": true, "append" : "+"}' ></h1>
      <h1 id="23-no" class="abs feSans-miniBd 23-no" style="top:302px;left:960px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 4}' ></h1>
      <h1 id="23-no" class="abs feSans-miniBd 23-no" style="top:425px;left:961px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 450}' ></h1>
      
      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 23-click-1" style="top:596px;left:-90px;" onclick="showTwentyThreePopOne()" src="/season2024-25/static/_content/23-click-1.png"/>
      <div id="23-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 23-pop-1" style="top:329px;left:36px;" src="/season2024-25/static/_content/23-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:616px;left:52px;width:285px;height:43px;" onclick="hideOverlay('23-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:345px;left:717px;width:43px;height:43px;" onclick="hideOverlay('23-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 23-click-2" style="top:571px;left:609px;" onclick="showTwentyThreePopTwo()" src="/season2024-25/static/_content/23-click-2.png"/>
      <div id="23-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 23-pop-2" style="top:68px;left:46px;" src="/season2024-25/static/_content/23-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:717px;left:67px;width:43px;height:43px;" onclick="hideOverlay('23-pop-2')"></div>
      </div>
      
      <!-- pop three -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 23-click-3" style="top:667px;left:609px;" onclick="showTwentyThreePopThree()" src="/season2024-25/static/_content/23-click-3.png"/>
      <div id="23-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 23-pop-3" style="top:68px;left:46px;" src="/season2024-25/static/_content/23-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:717px;left:67px;width:43px;height:43px;" onclick="hideOverlay('23-pop-3')"></div>
      </div>
 
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>  
      
      `,
      "script": `
        function onPageEnter() {
          pg23Anim = new TimelineMax();
          pg23Anim.fromTo(cOf("23-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[0])}}, 1.0)
          .fromTo(cOf("23-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[1])}}, 1.0)
          .fromTo(cOf("23-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[2])}}, 1.0)
          .fromTo(cOf("23-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("23-no")[3])}}, 1.0);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showTwentyThreePopOne() {
          showOverlay('23-pop-1')
        }

        function closeTwentyThreePopOne() {
          hideOverlay('23-pop-1')
        }

        function showTwentyThreePopTwo() {
          showOverlay('23-pop-2')
        }

        function closeTwentyThreePopTwo() {
          hideOverlay('23-pop-2')
        }

        function showTwentyThreePopThree() {
          showOverlay('23-pop-3')
        }

        function closeTwentyThreePopThree() {
          hideOverlay('23-pop-3')
        }

        function onPageLeave() {
          pg23Anim.stop();
          resetNumbers("23-no");
          closeTwentyThreePopOne();
          closeTwentyThreePopTwo();
          closeTwentyThreePopThree();
          removeContentLinks()
        }
      `,
      "searchText": "COMMUNITY BENEFITS AND OPPORTUNITIES Communities hosting our races should share in the excitement, opportunities and benefits created by the Championship, and throughout the 2024/25 Season, we continued to engage them through race-week activities, experiences and chances to attend Formula E events.  3,503  people engaged through community programmes  5,900+  complimentary race tickets distributed  4  cities expanded or enhanced Community Tours  A total of 3,503 people participated in community engagement activities globally, alongside nearly 6,000 complimentary race tickets were distributed to community groups, charities and local organisations, helping make Formula E accessible to a wider audience.  450  students engaged through Greater London Authority workshops  CLICK TO READ DIVERSITY IN MOTORSPORT FUND  CLICK TO READ MORE  CLICK TO READ SUPPORTING LOCAL RECOVERY IN VALENCIA  23  FORMULA EQUITY  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 23,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg24.jpg",
      "zoom": null,
      "content": `
      
      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 24-click-1" style="top:531px;left:-90px;" onclick="showTwentyFourPopOne()" src="/season2024-25/static/_content/24-click-1.png"/>
      <div id="24-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 24-pop-1" style="top:332px;left:35px;" src="/season2024-25/static/_content/24-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:551px;left:52px;width:285px;height:43px;" onclick="hideOverlay('24-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:722px;left:717px;width:43px;height:43px;" onclick="hideOverlay('24-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 24-click-2" style="top:583px;left:-151px;" onclick="showTwentyFourPopTwo()" src="/season2024-25/static/_content/24-click-2.png"/>
      <div id="24-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 24-pop-2" style="top:68px;left:50px;" src="/season2024-25/static/_content/24-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:717px;left:75px;width:43px;height:43px;" onclick="hideOverlay('24-pop-2')"></div>
      </div>
      
      <!-- pop three -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 24-click-3" style="top:667px;left:-188px;" onclick="showTwentyFourPopThree()" src="/season2024-25/static/_content/24-click-3.png"/>
      <div id="24-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 24-pop-3" style="top:68px;left:52px;" src="/season2024-25/static/_content/24-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:717px;left:73px;width:43px;height:43px;" onclick="hideOverlay('24-pop-3')"></div>

        <!-- animations -->
        <h1 id="24-no" class="abs feSans-miniBd 24-no" style="top:399px;left:516px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 92}' ></h1>
        <h1 id="24-no" class="abs feSans-miniBd 24-no" style="top:527px;left:516px; font-size: 3.4em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 15.5, "decimals" : 1}' ></h1>
        <img class="abs halfScale 24-text" style="top:658px;left:522px;" src="/season2024-25/static/_content/24-pop-3-text.png"/>
      </div>
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>   
  
      `,
      "script": `
        function onPageEnter() {
          pg24Anim = new TimelineMax();
          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showTwentyFourPopOne() {
          showOverlay('24-pop-1')
        }

        function closeTwentyFourPopOne() {
          hideOverlay('24-pop-1')
        }

        function showTwentyFourPopTwo() {
          showOverlay('24-pop-2')
        }

        function closeTwentyFourPopTwo() {
          hideOverlay('24-pop-2')
        }

        function showTwentyFourPopThree() {
          showOverlay('24-pop-3');
          pg24Anim = new TimelineMax();
          pg24Anim.fromTo(cOf("24-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("24-no")[0])}}, 1.0)
          .fromTo(cOf("24-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("24-no")[1])}}, 1.2)
          .fromTo(cOf("24-text"), 0.6, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.5);
        }

        function closeTwentyFourPopThree() {
          hideOverlay('24-pop-3')
          pg24Anim.stop();
        }

        function onPageLeave() {
          pg24Anim.stop();
          resetNumbers("24-no");
          closeTwentyFourPopOne();
          closeTwentyFourPopTwo();
          closeTwentyFourPopThree();
          removeContentLinks()
        }
      `,
      "searchText": "A MORE INCLUSIVE WORKFORCE Creating a more inclusive motorsport industry starts with creating a more inclusive organisation, and, in the 2024/25 Season, we formally launched ‘Driving Change’, our Equity, Diversity and Inclusion Strategy for 2025-2027.  PROGRESS TOWARDS OUR STRATEGIC AMBITIONS FOR 2027 TARGET: 50% Female, 50% Male  54.9% female representation  Developed over three years, the strategy brings together our internal people agenda and external social impact programmes under a single framework, helping us create greater opportunities within Formula E while supporting wider change across motorsport.  TARGET: 82% White, 18% Black, Asian, Mixed & Other  19.9% Black, Asian and other ethnic minority representation  CLICK TO READ MORE  TARGET: 56% Professional Class, 20% Intermediate Class, 24% Working Class  CLICK TO READ CREATING PATHWAYS TO THE INDUSTRY  21.0%  CLICK TO READ GREATER FLEXIBILITY FOR EMPLOYEE VOLUNTEERING  24  FORMULA EQUITY  working-class representation  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 24,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg25.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:406px; left:1159px; width:84px; height:86px;"></div>    
      
      `,
      "script": `
        function onPageEnter() {
          pg25Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "4 FORMULA FORMULA FORMULA FORMULA  ENVIRONMENT"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 25,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg26.jpg",
      "zoom": null,
      "content": `

      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 26-click-1" style="top:647px;left:729px;" onclick="showTwentySixPopOne()" src="/season2024-25/static/_content/26-click-1.png"/>
      <div id="26-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 26-pop-1" style="top:68px;left:13px;" src="/season2024-25/static/_content/26-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:90px;left:1148px;width:43px;height:43px;" onclick="hideOverlay('26-pop-1')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>   

      `,
      "script": `
        function onPageEnter() {
          pg26Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showTwentySixPopOne() {
          showOverlay('26-pop-1')
        }

        function closeTwentySixPopOne() {
          hideOverlay('26-pop-1')
        }

        function onPageLeave() {
          closeTwentySixPopOne();
          removeContentLinks()
        }
      `,
      "searchText": "BUILDING A PATHWAY TO SIGNIFICANT EMISSION REDUCTIONS The 2024/25 Season marked an important evolution in Formula E's environmental strategy. As expectations around climate accountability continue to evolve, we shifted our focus from carbon neutrality towards a certified Net Zero Pathway built on emissions reductions, enhanced carbon accounting and long-term planning.  OUR CARBON IMPACT Measurement and methodology of our 2024/25 Season carbon footprint. OUR REDUCTION EFFORTS Cutting our emissions against our baseline targets.  As a signatory of the UNFCCC Sports for Climate Action Framework, we are aligning our actions with the goals of the Paris Agreement and accelerating progress towards a low-carbon future. This chapter explores how Formula E is measuring emissions, reducing its environmental impact and building a credible pathway to net zero.  26  FORMULA ENVIRONMENT  THIS SECTION OF THE REPORT  NET ZERO IS OUR FINISH LINE  CLICK TO REVEAL OUR NET ZERO PATHWAY  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 26,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg27.jpg",
      "zoom": null,
      "content": `
    
      <h1 id="27-no" class="abs feSans-miniBd 27-no" style="top:38px;left:359px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 365}' ></h1>
      <img class="abs halfScale 27-tco2e" style="top:81px;left:710px;" src="/season2024-25/static/_content/tco2e.png"/>
      <img class="abs halfScale 27-block" style="top:38px;left:968px;" src="/season2024-25/static/_content/27-block-1.png"/>

      <h1 id="27-no" class="abs feSans-miniBd 27-no" style="top:337px;left:691px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 18}' ></h1>
      <img class="abs halfScale 27-perc" style="top:380px;left:882px;" src="/season2024-25/static/_content/percentage.png"/>
      <img class="abs halfScale 27-block" style="top:380px;left:979px;" src="/season2024-25/static/_content/27-block-1.png"/>

      <h1 id="27-no" class="abs feSans-miniBd 27-no" style="top:559px;left:351px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 2050}' ></h1>
      <img class="abs halfScale 27-block" style="top:602px;left:772px;" src="/season2024-25/static/_content/27-block-1.png"/>

      <h1 id="27-no" class="abs feSans-miniBd 27-no" style="top:553px;left:849px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 28}' ></h1>
      <img class="abs halfScale 27-perc" style="top:592px;left:1073px;" src="/season2024-25/static/_content/percentage.png"/>
      <img class="abs halfScale 27-block" style="top:592px;left:1171px;" src="/season2024-25/static/_content/27-block-1.png"/>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg27Anim = new TimelineMax();
          pg27Anim.fromTo(cOf("27-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("27-no")[0])}}, 1.0)
          pg27Anim.fromTo(cOf("27-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("27-no")[1])}}, 1.1)
          pg27Anim.fromTo(cOf("27-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("27-no")[2])}}, 1.2)
          pg27Anim.fromTo(cOf("27-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("27-no")[3])}}, 1.3);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg27Anim.stop();
          resetNumbers("27-no");
          removeContentLinks()
        }
      `,
      "searchText": "FORMULA FORMULA FORMULA FORMULA  365  tCO₂e  REDUCTION IN AVERAGE RACE EMISSIONS COMPARED WITH THE 2023/24 SEASON  ENVIRONMENT S_11  18  %  IN NUMBERS IN NUMBERS IN NUMBERS  REDUCTION IN EMISSIONS COMPARED WITH OUR 2018 BASELINE  IN NUMBERS  2050 28  %  NET ZERO ACHIEVED BY THIS DATE AT THE LATEST  27  FORMULA ENVIRONMENT  2024/25 SEASON  REDUCTION IN FREIGHTRELATED CARBON EMISSIONS  (COMPARED WITH THE 2023/24 SEASON)"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 27,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg28.jpg",
      "zoom": null,
      "content": `

      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 28-click-1" style="top:373px;left:262px;" onclick="showTwentyEightPopOne()" src="/season2024-25/static/_content/28-click-1.png"/>
      <div id="28-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 28-pop-1" style="top:68px;left:49px;" src="/season2024-25/static/_content/28-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:90px;left:1150px;width:43px;height:43px;" onclick="hideOverlay('28-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 28-click-2" style="top:501px;left:262px;" onclick="showTwentyEightPopTwo()" src="/season2024-25/static/_content/28-click-2.png"/>
      <div id="28-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 28-pop-2" style="top:68px;left:49px;" src="/season2024-25/static/_content/28-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:90px;left:1150px;width:43px;height:43px;" onclick="hideOverlay('28-pop-2')"></div>

        <!-- animations -->
        <h1 id="28-no" class="abs feSans-midiBd 28-no" style="top:206px;left:87px; font-size: 4.9em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;"  data-number='{"to": 27186, "comma": true}' ></h1>
        <h1 id="28-no" class="abs feSans-midiBd 28-no" style="top:344px;left:731px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;"  data-number='{"to": 7.6, "decimals": 1, "append": "%"}' ></h1>
        <h1 id="28-no" class="abs feSans-midiBd 28-no" style="top:368px;left:950px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;"  data-number='{"to": 3, "append" : "%"}' ></h1>
        <h1 id="28-no" class="abs feSans-midiBd 28-no" style="top:347px;left:1083px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;"  data-number='{"to": 0.5, "decimals" : 1, "append" : "%"}' ></h1>
        <h1 id="28-no" class="abs feSans-midiBd 28-no" style="top:570px;left:843px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;"  data-number='{"to": 4.4, "decimals" : 1, "append" : "%"}' ></h1>
        <h1 id="28-no" class="abs feSans-midiBd 28-no" style="top:569px;left:1020px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;"  data-number='{"to": 1.1, "decimals" : 1, "append": "%"}' ></h1>
        <h1 id="28-no" class="abs feSans-midiBd 28-no" style="top:658px;left:547px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;"  data-number='{"to": 31.8, "decimals" : 1, "append": "%"}' ></h1>
        <h1 id="28-no" class="abs feSans-midiBd 28-no" style="top:709px;left:228px; font-size: 1.15em; font-weight: 300; color: #00005a; padding: 0px; margin: 0px;"  data-number='{"to": 51.6, "decimals" : 1, "append": "%"}' ></h1>

        <!-- click for popup-3 of popup-2 -->
        <img class="abs halfScaleC halfpulse animatedpulse pointer 28-pop-2-click-1" style="top:142px;left:666px;" onclick="openPop('28-emissions-breakdown-race', '28-emissions-breakdown-race-1')" src="/season2024-25/static/_content/28-pop-2-click-1.png"/>

        <a href="https://drive.google.com/file/d/1p5tyXBxIwdDGDBbJGI93Q0tAvZRuA6lb/view" target="_blank" class="contentLinkNone">
          <img class="abs halfScaleC halfpulse animatedpulse pointer 28-pop-2-click-2" style="top:643px;left:666px;" onclick="openPop('28-emissions-breakdown-race', '28-emissions-breakdown-race-2')" src="/season2024-25/static/_content/28-pop-2-click-2.png"/>
        </a>

        <!-- pop-up-3 -->
        <div id="28-emissions-breakdown-race-1" class="28-emissions-breakdown-race hidden noclick">
          <img class="abs halfScale 28-emissions-breakdown-race-1" style="top:68px;left:49px;" src="/season2024-25/static/_content/28-pop-2-pop-3.png"/>
          <div class="abs contentLinkNone pointer" style="top:93px;left:1148px;width:41px;height:42px;" onclick="closePop('28-emissions-breakdown-race-1')"></div>
        </div>

        <!-- click for popup-3 of popup-2 -->

      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg28Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showTwentyEightPopOne() {
          showOverlay('28-pop-1')
        }

        function closeTwentyEightPopOne() {
          hideOverlay('28-pop-1')
        }

        function openPop(klass, id) {
        popups = cOf(klass);
        ele = idOf(id);
        for(var i=0; i<popups.length; i++) {
          popups[i].className = "28-emissions-breakdown-race hidden noclick";
          }
          ele.className = 'visible'
        }

        function closePop(id) {
          ele = idOf(id);
        ele.className = '28-emissions-breakdown-race hidden noclick'
        }

        function showTwentyEightPopTwo() {
          showOverlay('28-pop-2');
          pg28Anim = new TimelineMax();
          pg28Anim.fromTo(cOf("28-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("28-no")[0])}}, 1.0)
          .fromTo(cOf("28-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("28-no")[1])}}, 1.1)
          .fromTo(cOf("28-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("28-no")[2])}}, 1.1)
          .fromTo(cOf("28-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("28-no")[3])}}, 1.1)
          .fromTo(cOf("28-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("28-no")[4])}}, 1.1)
          .fromTo(cOf("28-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("28-no")[5])}}, 1.1)
          .fromTo(cOf("28-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("28-no")[6])}}, 1.1)
          .fromTo(cOf("28-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("28-no")[7])}}, 1.1);
        }

        function closeTwentyEightPopTwo() {
          hideOverlay('28-pop-2')
        }

        function onPageLeave() {
          pg28Anim.stop();
          resetNumbers("28-no");
          closeTwentyEightPopOne();
          closeTwentyEightPopTwo();
          removeContentLinks()
        }
      `,
      "searchText": "To ensure consistency and comparability over time, the 2024/25 Season emissions have been calculated using the same methodology applied to our baseline 2018/19 Season footprint and subsequent assessments in seasons 2022/23 and 2023/24. Emissions are calculated using the latest available emission factors and are reported across Scope 1, Scope 2 and Scope 3 categories. REPORTING BOUNDARY Formula E's carbon footprint assessment captures both direct and indirect greenhouse gas emissions generated across our operations and value chain.  CLICK TO READ HOW EMISSIONS ARE CALCULATED CLICK TO READ EMISSIONS BREAKDOWN  Direct emissions are those generated from sources owned or controlled by Formula E, including energy consumption at facilities, owned infrastructure and operational activities.  28  FORMULA ENVIRONMENT  2024/25 SEASON  SCOPE 1  Indirect emissions occur as a consequence of Formula E's activities but arise from sources not owned or controlled by the organisation. These include emissions associated with logistics, business travel, spectator travel, employee commuting, waste management and the race cars. Together, these emissions provide a comprehensive picture of Formula E's environmental impact across the championship lifecycle.  SCOPE 2  We measure our greenhouse gas (GHG) emissions using a methodology aligned with the Greenhouse Gas Protocol and ISO 14064-1.  SCOPE 3  OUR CARBON IMPACT  DIRECT EMISSIONS Direct emissions from sources owned or controlled by Formula E. Gas consumption at HQ Fuel consumed by generators at races (HVO and B100 biofuels)Fuel consumed by plant and machinery at races  INDIRECT ENERGY EMISSIONS Indirect emissions resulting from the generation of purchased energy. rid electricity consumed G at HQ and at races  OTHER INDIRECT EMISSIONS Indirect emissions generated throughout the value chain. Logistics Business travel Spectator travel Event catering Branding Employee commuting and homeworking Staff uniforms Race car production Waste generated Water consumed"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 28,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg29.jpg",
      "zoom": null,
      "content": `
      
      <h1 id="29-no" class="abs feSans-miniBd 29-no" style="top:337px;left:780px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 18, "append" : "%"}' ></h1>
      <h1 id="29-no" class="abs feSans-miniBd 29-no" style="top:381px;left:973px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 28, "append" : "%"}' ></h1>
      <h1 id="29-no" class="abs feSans-miniBd 29-no" style="top:508px;left:1044px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 20, "append" : "%"}' ></h1>

      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 29-click-1" style="top:80px;left:902px;" onclick="showTwentyNinePopOne()" src="/season2024-25/static/_content/29-click-1.png"/>
      <div id="29-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 29-pop-1" style="top:144px;left:733px;" src="/season2024-25/static/_content/29-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:692px;left:1155px;width:43px;height:43px;" onclick="hideOverlay('29-pop-1')"></div>

        <div class="addContentLink" style="top:603px;left:943px;width:178px;height:20px;">
          <a href="https://icvcm.org/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:624px;left:760px;width:378px;height:20px;">
          <a href="https://icvcm.org/" target="_blank"></a>
        </div>
        <div class="addContentLink" style="top:645px;left:760px;width:184px;height:20px;">
          <a href="https://icvcm.org/" target="_blank"></a>
        </div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 29-click-2" style="top:664px;left:-117px;" onclick="showTwentyNinePopTwo()" src="/season2024-25/static/_content/29-click-2.png"/>
      <div id="29-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 29-pop-2" style="top:68px;left:49px;" src="/season2024-25/static/_content/29-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:716px;left:73px;width:43px;height:43px;" onclick="hideOverlay('29-pop-2')"></div>

        <!-- animations -->
        <h1 id="29-no" class="abs feSans-miniBd 29-no" style="top:201px;left:825px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 261}' ></h1>
        <h1 id="29-no" class="abs feSans-miniMed 29-no" style="top:218px;left:949px; font-size: 0.95em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 2, "preppend" :"(", "append" : "%)"}' ></h1>

        <h1 id="29-no" class="abs feSans-miniBd 29-no" style="top:303px;left:864px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 13417, "comma" : true}' ></h1>
        <h1 id="29-no" class="abs feSans-miniMed 29-no" style="top:318px;left:1069px; font-size: 0.95em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 96, "preppend" :"(", "append" : "%)"}' ></h1>

        <h1 id="29-no" class="abs feSans-miniBd 29-no" style="top:401px;left:795px; font-size: 3.3em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 440}' ></h1>
        <h1 id="29-no" class="abs feSans-miniMed 29-no" style="top:415px;left:929px; font-size: 0.95em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 2, "preppend" :"(", "append" : "%)"}' ></h1>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg29Anim = new TimelineMax();
          pg29Anim.fromTo(cOf("29-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[0])}}, 1.0)
          .fromTo(cOf("29-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[1])}}, 1.1)
          .fromTo(cOf("29-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[2])}}, 1.2);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function showTwentyNinePopOne() {
          showOverlay('29-pop-1')
        }

        function closeTwentyNinePopOne() {
          hideOverlay('29-pop-1')
        }

        function showTwentyNinePopTwo() {
          showOverlay('29-pop-2');
          pg29Anim = new TimelineMax();
          pg29Anim.fromTo(cOf("29-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[3])}}, 1.0)
          .fromTo(cOf("29-no")[4], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[4])}}, 1.1)
          .fromTo(cOf("29-no")[5], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[5])}}, 1)
          .fromTo(cOf("29-no")[6], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[6])}}, 1.1)
          .fromTo(cOf("29-no")[7], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[7])}}, 1)
          .fromTo(cOf("29-no")[8], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("29-no")[8])}}, 1.1);
        }

        function closeTwentyNinePopTwo() {
          hideOverlay('29-pop-2');
          pg29Anim.stop();
          resetNumbers("29-no");
        }

        function onPageLeave() {
          pg29Anim.stop();
          resetNumbers("29-no");
          closeTwnetyNinePopOne();
          closeTwnetyNinePopTwo();
          removeContentLinks()
        }
      `,
      "searchText": "OUR REDUCTION EFFORTS Overall, our carbon emissions fell by 18% compared with the 2023/24 Season and by 18% against our 2018 baseline year. Average emissions per race decreased from 2,075.75 tCO₂e in the 2023/24 Season to 1,699.13 tCO₂e in the 2024/25 Season. While freight has remained our largest source of emissions since the first season in 2014/15, we reduced freight-related emissions by 28% compared with the 2023/24 Season. A key driver of this improvement was reducing our air freight operations from three aircraft to two during the 2024/25 Season, delivering significant carbon savings while also reducing logistics costs by millions of pounds.  We achieved this by prioritising grid connection as the most efficient energy source – backed by certified renewable sources – and swapping traditional fuels for clean biofuels such as Hydrotreated Vegetable Oil (HVO) in all temporary generators, supplemented by solar energy and battery storage. We also reduced operational emissions by 20% to 1,204 tCO₂e. This was driven by a greater use of remote production, alongside continued improvements in energy efficiency and increased use of renewable energy.  18% reduction in overall emissions  28% drop in freightrelated emissions  decrease in operational emissions  CLICK TO READ ABOUT OUR FOCUS ON FREIGHT  FORMULA ENVIRONMENT  2024/25 SEASON V 2023/24 SEASON  20%  The 2024/25 Season marked our first season running on 100% renewable energy to power all races.  29  CLICK TO READ ABOUT ADDRESSING OUR RESIDUAL EMISSIONS  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 29,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg30.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:406px; left:1159px; width:84px; height:86px;"></div>  
      
      `,
      "script": `
        function onPageEnter() {
          pg30Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "5 FORMULA FORMULA FORMULA FORMULA  ECOSYSTEM"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 30,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg31.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg5Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "BRINGING DIFFERENT PARTS OF OUR ECOSYSTEM TOGETHER TO TURN INDIVIDUAL EFFORTS INTO COLLECTIVE PROGRESS.  Formula E is built around speed. And speed is exactly what the world needs if we are to create a more sustainable and equitable future.  Our partners, teams and host cities give us an ecosystem through which we can help accelerate sustainable human progress. Across that network are some of the world’s leading minds in technology, mobility, energy, business and sustainability – each bringing ideas, expertise and solutions that can contribute to tackling shared challenges. Our role is to help connect them. By creating opportunities for collaboration, sharing knowledge and bringing different parts of our ecosystem together, we can help turn individual efforts into collective progress.  31  FORMULA ECOSYSTEM  2024/25 SEASON  THIS SECTION OF THE REPORT  VALUE THROUGH VALUES  PARTNERS ON OUR NET ZERO JOURNEY Exploring how Google Cloud, DHL and Infosys help us reduce hard-to-abate emissions. ENVISION RACING NAMED SUSTAINABILITY CHAMPION Ambition and results of the team’s Race Against Climate Change programme wins recognition. CONVERSATIONS TO UNLOCK IDEAS Change.Accelerated.Live brought more leaders together to drive innovative conversations and ideas for climate action."
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 31,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg32.jpg",
      "zoom": null,
      "content": `

      <h1 id="32-no" class="abs feSans-miniBd 32-no" style="top:27px;left:351px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 6}' ></h1>

      <h1 id="32-no" class="abs feSans-miniBd 32-no" style="top:362px;left:626px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 422}' ></h1>
      <img class="abs halfScale 32-symbol" style="top:403px;left:953px;" src="/season2024-25/static/_content/m-symbol.png"/>

      <h1 id="32-no" class="abs feSans-miniBd 32-no" style="top:543px;left:704px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 1.39, "decimals" : 2}' ></h1>
      <img class="abs halfScale 32-symbol" style="top:586px;left:1043px;" src="/season2024-25/static/_content/bn.png"/>

      <h1 id="32-no" class="abs feSans-miniBd 32-no" style="top:590px;left:343px; font-size: 8.5em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 58}' ></h1>
      <img class="abs halfScale 32-perc" style="top:632px;left:567px;" src="/season2024-25/static/_content/percentage.png"/>
      <img class="abs halfScale 32-perc" style="top:607px;left:663px;" src="/season2024-25/static/_content/32-block-1.png"/>
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg32Anim = new TimelineMax();
          pg32Anim.fromTo(cOf("32-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[0])}}, 1.0)
          .fromTo(cOf("32-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[1])}}, 1.1)
          .fromTo(cOf("32-no")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[2])}}, 1.2)
          .fromTo(cOf("32-no")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("32-no")[3])}}, 1.3);

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          pg32Anim.stop();
          resetNumbers("32-no");
          removeContentLinks()
        }
      `,
      "searchText": "FORMULA FORMULA FORMULA FORMULA  6  CHANGE.ACCELERATED.LIVE EVENTS IN - MIAMI - MONACO  - TOKYO - SHANGHAI  - JAKARTA - LONDON  ECOSYSTEM S_11  422 BN % 1.39 58 IN NUMBERS IN NUMBERS IN NUMBERS IN NUMBERS  FORMULA ECOSYSTEM  M  FANS – A 13% INCREASE ON 2023/24 SEASON  OF FANS ‘HIGHLY ENGAGED’  32  ENVISION RACING RECOGNISED AS FORMULA E SUSTAINABILITY CHAMPION  2024/25 SEASON  DIGITAL IMPRESSIONS – A 14% INCREASE ON 2023/24 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 32,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg33.jpg",
      "zoom": null,
      "content": `
      
      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 33-click-1" style="top:681px;left:228px;" onclick="showThirtyThreePopOne()" src="/season2024-25/static/_content/33-click-1.png"/>
      <div id="33-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 33-pop-1" style="top:52px;left:50px;" src="/season2024-25/static/_content/33-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:81px;left:1143px;width:43px;height:43px;" onclick="hideOverlay('33-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 33-click-2" style="top:681px;left:538px;" onclick="showThirtyThreePopTwo()" src="/season2024-25/static/_content/33-click-2.png"/>
      <div id="33-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 33-pop-2" style="top:52px;left:50px;" src="/season2024-25/static/_content/33-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:81px;left:1143px;width:43px;height:43px;" onclick="hideOverlay('33-pop-2')"></div>
      </div>

      <!-- pop three -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 33-click-3" style="top:681px;left:848px;" onclick="showThirtyThreePopThree()" src="/season2024-25/static/_content/33-click-3.png"/>
      <div id="33-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 33-pop-3" style="top:52px;left:50px;" src="/season2024-25/static/_content/33-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:81px;left:1143px;width:43px;height:43px;" onclick="hideOverlay('33-pop-3')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg33Anim = new TimelineMax();

          setTimeout(function(){
                addContentLinks();
            },1000)
        }

        function showThirtyThreePopOne() {
          showOverlay('33-pop-1')
        }

        function closeThirtyThreePopOne() {
          hideOverlay('33-pop-1')
        }

        function showThirtyThreePopTwo() {
          showOverlay('33-pop-2')
        }

        function closeThirtyThreePopTwo() {
          hideOverlay('33-pop-2')
        }

        function showThirtyThreePopThree() {
          showOverlay('33-pop-3')
        }

        function closeThirtyThreePopThree() {
          hideOverlay('33-pop-3')
        }

        function onPageLeave() {
          pg33Anim.stop();
          resetNumbers("33-no");
          closeThirtyThreePopOne();
          closeThirtyThreePopTwo();
          closeThirtyThreePopThree();
          removeContentLinks()
        }
      `,
      "searchText": "PARTNERS ON OUR JOURNEY TO NET ZERO Achieving net zero requires collaboration. We work with partners that bring the expertise, technology and ambition needed to help us reduce hard-to-abate emissions, improve operational efficiency and unlock new solutions to sustainability challenges across the Championship.  33  FORMULA ECOSYSTEM  MAKING DATA ANALYSIS LESS CARBON INTENSIVE WITH GOOGLE CLOUD  TAKING SIGNIFICANT STEPS TO REDUCE FREIGHT EMISSIONS WITH DHL  AI TO IDENTIFY CARBON REDUCTION OPPORTUNITIES WITH INFOSYS  CLICK TO READ  CLICK TO READ  CLICK TO READ  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 33,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg34.jpg",
      "zoom": null,
      "content": `

      <h1 id="34-no" class="abs feSans-miniBd 34-no" style="top:657px;left:422px; font-size: 3.34em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 10, "append" : "%"}' ></h1>

      <h1 id="34-no" class="abs feSans-miniBd 34-no" style="top:657px;left:717px; font-size: 3.34em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;"  data-number='{"to": 5}' ></h1>
      
      <!-- pop one -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 34-click-1" style="top:568px;left:-87px;" onclick="showThirtyFourPopOne()" src="/season2024-25/static/_content/34-click-1.png"/>
      <div id="34-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 34-pop-1" style="top:385px;left:35px;" src="/season2024-25/static/_content/34-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:590px;left:56px;width:285px;height:43px;" onclick="hideOverlay('34-pop-1')"></div>
        <div class="abs contentLinkNone pointer" style="top:714px;left:1127px;width:43px;height:43px;" onclick="hideOverlay('34-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 34-click-2" style="top:633px;left:-101px;" onclick="showThirtyFourPopTwo()" src="/season2024-25/static/_content/34-click-2.png"/>
      <div id="34-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 34-pop-2" style="top:52px;left:50px;" src="/season2024-25/static/_content/34-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:81px;left:1143px;width:43px;height:43px;" onclick="hideOverlay('34-pop-2')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg34Anim = new TimelineMax();
          pg34Anim.fromTo(cOf("34-no")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[0])}}, 1.0)
          .fromTo(cOf("34-no")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf("34-no")[1])}}, 1.1);

          setTimeout(function(){
                addContentLinks();
            },1000)
        }

        function showThirtyFourPopOne() {
          showOverlay('34-pop-1')
        }

        function closeThirtyFourPopOne() {
          hideOverlay('34-pop-1')
        }

        function showThirtyFourPopTwo() {
          showOverlay('34-pop-2')
        }

        function closeThirtyFourPopTwo() {
          hideOverlay('34-pop-2')
        }

        function onPageLeave() {
          pg34Anim.stop();
          resetNumbers("34-no");
          closeThirtyFourPopOne();
          closeThirtyFourPopTwo();
          removeContentLinks()
        }
      `,
      "searchText": "ENVISION RACING NAMED SUSTAINABILITY CHAMPION Our teams have the opportunity to use their platforms, partnerships and expertise to accelerate change, and in the 2024/25 Season, Envision Racing demonstrated what that can look like at its best. Envision Racing was named Formula E’s Sustainability Champion following its most ambitious season of sustainability activity to date. Through its Race Against Climate Change (RACC) programme, the team combined action to reduce its own environmental impact with a global campaign designed to engage people in climate solutions.  CLICK TO READ MORE  CLICK TO READ ABOUT MAHINDRA PLANET POSITIVE PROGRAMME  34  FORMULA ECOSYSTEM  10%  carbon emissions reduction against it baseline  2024/25 SEASON  5  Race Against Climate Change events hosted  Sustainability Working Group established"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 34,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg35.jpg",
      "zoom": null,
      "content": `
      
      <!-- pop one -->
      <img class="abs halfScaleC pointer 35-click-1" style="top:66px;left:243px;" onclick="showThirtyFivePopOne()" src="/season2024-25/static/_content/35-click-1.png"/>
      <div id="35-pop-1" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 35-pop-1" style="top:52px;left:51px;" src="/season2024-25/static/_content/35-pop-1.png"/>
        <div class="abs contentLinkNone pointer" style="top:83px;left:83px;width:43px;height:43px;" onclick="hideOverlay('35-pop-1')"></div>
      </div>

      <!-- pop two -->
      <img class="abs halfScaleC pointer 35-click-2" style="top:66px;left:522px;" onclick="showThirtyFivePopTwo()" src="/season2024-25/static/_content/35-click-2.png"/>
      <div id="35-pop-2" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 35-pop-2" style="top:52px;left:51px;" src="/season2024-25/static/_content/35-pop-2.png"/>
        <div class="abs contentLinkNone pointer" style="top:83px;left:83px;width:43px;height:43px;" onclick="hideOverlay('35-pop-2')"></div>
      </div>

      <!-- pop three -->
      <img class="abs halfScaleC pointer 35-click-3" style="top:66px;left:800px;" onclick="showThirtyFivePopThree()" src="/season2024-25/static/_content/35-click-3.png"/>
      <div id="35-pop-3" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 35-pop-3" style="top:52px;left:51px;" src="/season2024-25/static/_content/35-pop-3.png"/>
        <div class="abs contentLinkNone pointer" style="top:83px;left:1138px;width:43px;height:43px;" onclick="hideOverlay('35-pop-3')"></div>
      </div>

      <!-- pop four -->
      <img class="abs halfScaleC pointer 35-click-4" style="top:351px;left:243px;" onclick="showThirtyFivePopFour()" src="/season2024-25/static/_content/35-click-4.png"/>
      <div id="35-pop-4" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 35-pop-4" style="top:52px;left:51px;" src="/season2024-25/static/_content/35-pop-4.png"/>
        <div class="abs contentLinkNone pointer" style="top:83px;left:83px;width:43px;height:43px;" onclick="hideOverlay('35-pop-4')"></div>
      </div>

      <!-- pop five -->
      <img class="abs halfScaleC pointer 35-click-5" style="top:351px;left:521px;" onclick="showThirtyFivePopFive()" src="/season2024-25/static/_content/35-click-5.png"/>
      <div id="35-pop-5" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 35-pop-5" style="top:52px;left:51px;" src="/season2024-25/static/_content/35-pop-5.png"/>
        <div class="abs contentLinkNone pointer" style="top:83px;left:83px;width:43px;height:43px;" onclick="hideOverlay('35-pop-5')"></div>
      </div>

      <!-- pop six -->
      <img class="abs halfScaleC pointer 35-click-6" style="top:351px;left:799px;" onclick="showThirtyFivePopSix()" src="/season2024-25/static/_content/35-click-6.png"/>
      <div id="35-pop-6" class="standardTransition contentOverlay hidden noclick">
        <img class="abs halfScale 35-pop-6" style="top:52px;left:51px;" src="/season2024-25/static/_content/35-pop-6.png"/>
        <div class="abs contentLinkNone pointer" style="top:83px;left:83px;width:43px;height:43px;" onclick="hideOverlay('35-pop-6')"></div>
      </div>

      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>

      `,
      "script": `
        function onPageEnter() {
          pg35Anim = new TimelineMax();

          setTimeout(function(){
            addContentLinks();
          },1000)
        }

        function showThirtyFivePopOne() {
          showOverlay('35-pop-1')
        }

        function closeThirtyFivePopOne() {
          hideOverlay('35-pop-1')
        }

        function showThirtyFivePopTwo() {
          showOverlay('35-pop-2')
        }

        function closeThirtyFivePopTwo() {
          hideOverlay('35-pop-2')
        }

         function showThirtyFivePopThree() {
          showOverlay('35-pop-3')
        }

        function closeThirtyFivePopThree() {
          hideOverlay('35-pop-3')
        }

        function showThirtyFivePopFour() {
          showOverlay('35-pop-4')
        }

        function closeThirtyFivePopFour() {
          hideOverlay('35-pop-4')
        }

        function showThirtyFivePopFive() {
          showOverlay('35-pop-5')
        }

        function closeThirtyFivePopFive() {
          hideOverlay('35-pop-5')
        }

        function showThirtyFivePopSix() {
          showOverlay('35-pop-6')
        }

        function closeThirtyFivePopSix() {
          hideOverlay('35-pop-6')
        }

        function onPageLeave() {
          pg35Anim.stop();
          resetNumbers("35-no");
          closeThirtyFivePopOne();
          closeThirtyFivePopTwo();
          closeThirtyFivePopThree();
          closeThirtyFivePopFour();
          closeThirtyFivePopFive();
          closeThirtyFivePopSix();
          removeContentLinks()
        }
      `,
      "searchText": "CONVERSATIONS TO UNLOCK IDEAS Through Change. Accelerated. Live., we use our global platform to bring together leaders from business, government, technology and sport to explore how innovation can help address climate change and accelerate positive change. Taking place alongside races in cities around the world, each event focuses on the challenges and opportunities most relevant to its location – from the future of mobility and smart cities to artificial intelligence, climate finance and sustainable innovation. By connecting different industries, perspectives and areas of expertise, we aim to create conversations that can unlock new ideas, strengthen collaboration and help turn ambition into action across business and society.  35  FORMULA ECOSYSTEM  CLICK BELOW TO READ EACH EVENT FOCUSES  DIGITAL FUTURES MIAMI  SMART CITIES MONACO  REIMAGINING TRANSPORTATION TOKYO  INNOVATION IN MOTION SHANGHAI  CHANGE. ACCELERATED.LIVE JAKARTA  SUSTAINABLE INNOVATION LONDON  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 35,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg36.jpg",
      "zoom": null,
      "content": `
      
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:406px; left:1159px; width:84px; height:86px;"></div>  

      `,
      "script": `
        function onPageEnter() {
          pg36Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "6 GRI GRI GRI GRI  INDEX"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 36,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg37.jpg",
      "zoom": null,
      "content": `
      
      <!--- scrollable table --->

      <div id="scrollable-container" class="abs scroll-container" style="width: 1080px; height: 383px; top: 315px; left: 67px; overflow-y: scroll;">
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-1.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-2.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-3.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-4.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-5.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-6.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-7.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-8.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-9.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-10.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-11.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-12.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-13.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-14.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-15.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-16.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-17.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-18.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-19.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-20.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-21.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-22.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-23.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-24.jpg"/>
        <img style="width: 100%; height: auto; position: relative;" src="/season2024-25/static/_content/pdf-25.jpg"/>
      </div>

      <!--- clickable tab --->
      <img class="abs halfScaleC halfpulse animatedpulse pointer 37-tab" style="top:744px;left:207px;" src="/season2024-25/static/_content/37-click-tab.png"/>

      <a href="https://sustainabilityreport.fiaformulae.com/season2024-25/static/_content/gri_content_index_table_final.pdf" target="_blank" class="contentLinkNone">
        <img class="abs halfScaleC halfpulse animatedpulse pointer 37-tab" style="top:744px;left:207px;" src="/season2024-25/static/_content/37-click-tab.png"/>
      </a>
            
      <div class="addContentLink" onclick="Publish.goToNextPage();" style="top:430px; left:1231px; width:33px; height:35px;"></div>
      
      `,
      "script": `
        function onPageEnter() {
          pg37Anim = new TimelineMax();

          setTimeout(function(){
              addContentLinks();
          },1000)
        }

        function onPageLeave() {
          removeContentLinks()
        }
      `,
      "searchText": "GRI  CONTENT INDEX GRI CONTENT INDEX  Formula E has reported the information cited in this GRI content index for the period 28th January 2024 - 14th August 2025 with reference to the GRI Standards.  Formula E has reported the information cited in this GRI content index for the period 28th January 2023 – 14th August 2024 with reference to the GRI Standards.  SCROLL TO READ TABLE  GRI STANDARDS  DISCLOSURE  LOCATION  bn2-1 Organizational details  2-1-a Organisation legal name – Formula E Operations Limited 2-1-b Ownership and legal form On 20th February 2013, Formula E Operations Limited was incorporated under the Companies Act 2006 as a private limited company with its registered office in England. Shares are owned by Formula E Holdings Limited (Hong Kong).  General disclosures GRI 2: General Disclosures 2021  2-1-c Location of Headquarters Formula E Operations Limited and Formula E Race Operations, 3 Shortlands, 9th Floor, London, W6 8DA, United Kingdom. 2-1-d Countries of operations London Headquarters: Formula E Operations Limited and Formula E Race Operations, 3 Shortlands, 9th Floor, London, W6 8DA, United Kingdom. Hong Kong Office: Formula E Holdings Limited, Level 54, Hopewell Centre, 183 Queen’s Road East, Hong Kong. Mexico City Office: Formula E Mexico Race Operations S De RL DE CV, Avenida Ejercito Nacional, No. 418-307, Polanco V Sección, Miguel Hidalgo, C.P. 11560 Ciudad de México, Mexico. US Office: 28 Old Rudnick Lane, Dover, Delaware, US, 19901 Brazil Office: Alameda Santos 1293, Sao Paulo, 01419-904 Sao Paulo, Brazil Japan Office: c/o Ark Outsourcing KK, 4-3-5-704, Ebisu, Shibuya-ku, Tokyo, Japan 2-3 Reporting period, frequency and contact point  1  37  GRI INDEX  GRI INDEX  2-3-a Reporting period and frequency – 1st October 2023 to 30th September 2024 2-3-b Financial reporting period: 28th January 2023 – 14th August 2024 2-3-c Publish date – April/May 2025 2-3-d Contact point for questions regarding the report – sustainabilty@fiaformulae.com  OF FANS CLICK ‘HIGHLYTO ENGAGED’ DOWNLOAD FULL TABLE SEASON 10 SUSTAINABILITY REPORT  2024/25 SEASON"
    }],[{
      "guid": "00000000-0000-0000-0000-000000000000",
      "title": "",
      "index": 37,
      "subIndex": 0,
      "startIndex": 0,
      "original": "pg38.jpg",
      "zoom": null,
      "content": ``,
      "script": `
        function onPageEnter() {
        }

        function onPageLeave() {
        }
      `,
      "searchText": ""
    }]],
    "script": `
    function idOf(id) {
      return document.getElementById(id)
    }

    function cOf(klass) {
      return document.getElementsByClassName(klass)
    }

    function removeContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'addContentLink'
      })
    }

    function addContentLinks() {
      var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))
      contentLinks.map(function callback(e) {
        return e.className = 'contentLink addContentLink'
      })
    }

    function showOverlay(idx) {
      idOf(idx).className = 'contentOverlay visible'
    }

    function hideOverlay(idx) {
      idOf(idx).className = 'contentOverlay hidden noclick'
    }

    function animateNumber(element){
      if(element.getAttribute("data-number")){
        var args = JSON.parse(element.getAttribute("data-number"));
        var from = 0;
        var to = 100;
        var append = "";
        var preppend = "";
        var decimals = 0;
        var duration = 1;
        var ease = "Linear.easeNone";
        var comma = false;
        var separator = ",";
        var decChar = ".";
        for(obj in args){
          if(obj == "from") from = args[obj];
          if(obj == "to") to = args[obj];
          if(obj == "append") append = args[obj];
          if(obj == "preppend") preppend = args[obj];
          if(obj == "decimals") decimals = args[obj];
          if(obj == "duration") duration = args[obj];
          if(obj == "ease") ease = args[obj];
          if(obj == "comma") comma = args[obj];
          if(obj == "separator") separator = args[obj];
          if(obj == "decChar") decChar = args[obj];
        }
        var obj = {number: from}
        TweenMax.to(obj, duration, {number: to, onUpdate: function(){
          if(comma){
            console.log(obj.number)
            var str = obj.number.toFixed(decimals).toString();
            var predec = str.split(/^d*/)[0];
            console.log("PREDEC", predec, typeof(predec));
            var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')
            var comp = newstr.replace(/^,/, '')
            console.log("NEWSTR", newstr, typeof(newstr));
            // console.log({newstr})
            // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : "";
            // if(dp[0]) dp = dp[0].replace(".", decChar);
            var dp = "";
            element.innerHTML = preppend+comp+dp+append;
          }else{
            element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(".", decChar)+append;
          }
        }, ease: eval(ease)});
      }else{
        return;
      }
    }

    function resetNumbers(ele){
      var numbers = cOf(ele)
      for(var i=0; i<numbers.length; i++) {
        numbers[i].innerText= ""
      }
    }

    function mailChimpSubmit(){
      $('#mc-embedded-subscribe-form').submit(function (e) {
        var that = $(this);
        var mailchimpSubmit = $(this).find('input[type=submit]');
        var errorResponse = $('#mce-error-response');
        var successResponse = $('#mce-success-response');

        e.preventDefault();

        $.ajax({
          method: 'GET',
          url: that.attr('action'),
          data: that.serialize(),
          dataType: 'jsonp',
          success: function(data) {
            console.log('AJAX SUCCESS')
          // If there was an error then show the error message.
            if (data.result === 'error') {
              console.log('AJAX ERROR')
              // If the error has an error code at front then alter the message to not include the error code and hyphen.
              if(data.msg.indexOf('0') === 0) {
                data.msg = data.msg.slice(3);
              }
              errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);
            }
            // If success then show message
            else {
              successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);
            }
          }
        });
      });
    }
  `,
  "mobilePages": null,
  "mobileTemplate": null,
}



// WEBPACK FOOTER //
// ./src/document.js